(function () {
function $6f5202a002b4b4fe$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6f5202a002b4b4fe$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6f5202a002b4b4fe$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6f5202a002b4b4fe$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $6f5202a002b4b4fe$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $6f5202a002b4b4fe$var$CREATED = 1;
var $6f5202a002b4b4fe$var$MOUNTED = 2;
var $6f5202a002b4b4fe$var$IDLE = 3;
var $6f5202a002b4b4fe$var$MOVING = 4;
var $6f5202a002b4b4fe$var$SCROLLING = 5;
var $6f5202a002b4b4fe$var$DRAGGING = 6;
var $6f5202a002b4b4fe$var$DESTROYED = 7;
var $6f5202a002b4b4fe$var$STATES = {
    CREATED: $6f5202a002b4b4fe$var$CREATED,
    MOUNTED: $6f5202a002b4b4fe$var$MOUNTED,
    IDLE: $6f5202a002b4b4fe$var$IDLE,
    MOVING: $6f5202a002b4b4fe$var$MOVING,
    SCROLLING: $6f5202a002b4b4fe$var$SCROLLING,
    DRAGGING: $6f5202a002b4b4fe$var$DRAGGING,
    DESTROYED: $6f5202a002b4b4fe$var$DESTROYED
};
function $6f5202a002b4b4fe$var$empty(array) {
    array.length = 0;
}
function $6f5202a002b4b4fe$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $6f5202a002b4b4fe$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($6f5202a002b4b4fe$var$slice(arguments, 1)));
}
var $6f5202a002b4b4fe$var$nextTick = setTimeout;
var $6f5202a002b4b4fe$var$noop = function noop() {};
function $6f5202a002b4b4fe$var$raf(func) {
    return requestAnimationFrame(func);
}
function $6f5202a002b4b4fe$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $6f5202a002b4b4fe$var$isObject(subject) {
    return !$6f5202a002b4b4fe$var$isNull(subject) && $6f5202a002b4b4fe$var$typeOf("object", subject);
}
var $6f5202a002b4b4fe$var$isArray = Array.isArray;
var $6f5202a002b4b4fe$var$isFunction = $6f5202a002b4b4fe$var$apply($6f5202a002b4b4fe$var$typeOf, "function");
var $6f5202a002b4b4fe$var$isString = $6f5202a002b4b4fe$var$apply($6f5202a002b4b4fe$var$typeOf, "string");
var $6f5202a002b4b4fe$var$isUndefined = $6f5202a002b4b4fe$var$apply($6f5202a002b4b4fe$var$typeOf, "undefined");
function $6f5202a002b4b4fe$var$isNull(subject) {
    return subject === null;
}
function $6f5202a002b4b4fe$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $6f5202a002b4b4fe$var$toArray(value) {
    return $6f5202a002b4b4fe$var$isArray(value) ? value : [
        value
    ];
}
function $6f5202a002b4b4fe$var$forEach(values, iteratee) {
    $6f5202a002b4b4fe$var$toArray(values).forEach(iteratee);
}
function $6f5202a002b4b4fe$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $6f5202a002b4b4fe$var$push(array, items) {
    array.push.apply(array, $6f5202a002b4b4fe$var$toArray(items));
    return array;
}
function $6f5202a002b4b4fe$var$toggleClass(elm, classes, add) {
    if (elm) $6f5202a002b4b4fe$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $6f5202a002b4b4fe$var$addClass(elm, classes) {
    $6f5202a002b4b4fe$var$toggleClass(elm, $6f5202a002b4b4fe$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $6f5202a002b4b4fe$var$append(parent, children) {
    $6f5202a002b4b4fe$var$forEach(children, parent.appendChild.bind(parent));
}
function $6f5202a002b4b4fe$var$before(nodes, ref) {
    $6f5202a002b4b4fe$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $6f5202a002b4b4fe$var$matches(elm, selector) {
    return $6f5202a002b4b4fe$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $6f5202a002b4b4fe$var$children(parent, selector) {
    var children2 = parent ? $6f5202a002b4b4fe$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $6f5202a002b4b4fe$var$matches(child, selector);
    }) : children2;
}
function $6f5202a002b4b4fe$var$child(parent, selector) {
    return selector ? $6f5202a002b4b4fe$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $6f5202a002b4b4fe$var$ownKeys = Object.keys;
function $6f5202a002b4b4fe$var$forOwn(object, iteratee, right) {
    if (object) (right ? $6f5202a002b4b4fe$var$ownKeys(object).reverse() : $6f5202a002b4b4fe$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $6f5202a002b4b4fe$var$assign(object) {
    $6f5202a002b4b4fe$var$slice(arguments, 1).forEach(function(source) {
        $6f5202a002b4b4fe$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $6f5202a002b4b4fe$var$merge(object) {
    $6f5202a002b4b4fe$var$slice(arguments, 1).forEach(function(source) {
        $6f5202a002b4b4fe$var$forOwn(source, function(value, key) {
            if ($6f5202a002b4b4fe$var$isArray(value)) object[key] = value.slice();
            else if ($6f5202a002b4b4fe$var$isObject(value)) object[key] = $6f5202a002b4b4fe$var$merge({}, $6f5202a002b4b4fe$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $6f5202a002b4b4fe$var$omit(object, keys) {
    $6f5202a002b4b4fe$var$forEach(keys || $6f5202a002b4b4fe$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $6f5202a002b4b4fe$var$removeAttribute(elms, attrs) {
    $6f5202a002b4b4fe$var$forEach(elms, function(elm) {
        $6f5202a002b4b4fe$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $6f5202a002b4b4fe$var$setAttribute(elms, attrs, value) {
    if ($6f5202a002b4b4fe$var$isObject(attrs)) $6f5202a002b4b4fe$var$forOwn(attrs, function(value2, name) {
        $6f5202a002b4b4fe$var$setAttribute(elms, name, value2);
    });
    else $6f5202a002b4b4fe$var$forEach(elms, function(elm) {
        $6f5202a002b4b4fe$var$isNull(value) || value === "" ? $6f5202a002b4b4fe$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $6f5202a002b4b4fe$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $6f5202a002b4b4fe$var$isString(attrs) ? $6f5202a002b4b4fe$var$addClass(elm, attrs) : $6f5202a002b4b4fe$var$setAttribute(elm, attrs);
    parent && $6f5202a002b4b4fe$var$append(parent, elm);
    return elm;
}
function $6f5202a002b4b4fe$var$style(elm, prop, value) {
    if ($6f5202a002b4b4fe$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$6f5202a002b4b4fe$var$isNull(value)) elm.style[prop] = "" + value;
}
function $6f5202a002b4b4fe$var$display(elm, display2) {
    $6f5202a002b4b4fe$var$style(elm, "display", display2);
}
function $6f5202a002b4b4fe$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $6f5202a002b4b4fe$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $6f5202a002b4b4fe$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $6f5202a002b4b4fe$var$rect(target) {
    return target.getBoundingClientRect();
}
function $6f5202a002b4b4fe$var$remove(nodes) {
    $6f5202a002b4b4fe$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $6f5202a002b4b4fe$var$parseHtml(html) {
    return $6f5202a002b4b4fe$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $6f5202a002b4b4fe$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $6f5202a002b4b4fe$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $6f5202a002b4b4fe$var$queryAll(parent, selector) {
    return selector ? $6f5202a002b4b4fe$var$slice(parent.querySelectorAll(selector)) : [];
}
function $6f5202a002b4b4fe$var$removeClass(elm, classes) {
    $6f5202a002b4b4fe$var$toggleClass(elm, classes, false);
}
function $6f5202a002b4b4fe$var$timeOf(e) {
    return e.timeStamp;
}
function $6f5202a002b4b4fe$var$unit(value) {
    return $6f5202a002b4b4fe$var$isString(value) ? value : value ? value + "px" : "";
}
var $6f5202a002b4b4fe$var$PROJECT_CODE = "splide";
var $6f5202a002b4b4fe$var$DATA_ATTRIBUTE = "data-" + $6f5202a002b4b4fe$var$PROJECT_CODE;
function $6f5202a002b4b4fe$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $6f5202a002b4b4fe$var$PROJECT_CODE + "] " + (message || ""));
}
var $6f5202a002b4b4fe$var$min = Math.min, $6f5202a002b4b4fe$var$max = Math.max, $6f5202a002b4b4fe$var$floor = Math.floor, $6f5202a002b4b4fe$var$ceil = Math.ceil, $6f5202a002b4b4fe$var$abs = Math.abs;
function $6f5202a002b4b4fe$var$approximatelyEqual(x, y, epsilon) {
    return $6f5202a002b4b4fe$var$abs(x - y) < epsilon;
}
function $6f5202a002b4b4fe$var$between(number, x, y, exclusive) {
    var minimum = $6f5202a002b4b4fe$var$min(x, y);
    var maximum = $6f5202a002b4b4fe$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $6f5202a002b4b4fe$var$clamp(number, x, y) {
    var minimum = $6f5202a002b4b4fe$var$min(x, y);
    var maximum = $6f5202a002b4b4fe$var$max(x, y);
    return $6f5202a002b4b4fe$var$min($6f5202a002b4b4fe$var$max(minimum, number), maximum);
}
function $6f5202a002b4b4fe$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $6f5202a002b4b4fe$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $6f5202a002b4b4fe$var$format(string, replacements) {
    $6f5202a002b4b4fe$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $6f5202a002b4b4fe$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $6f5202a002b4b4fe$var$ids = {};
function $6f5202a002b4b4fe$var$uniqueId(prefix) {
    return "" + prefix + $6f5202a002b4b4fe$var$pad($6f5202a002b4b4fe$var$ids[prefix] = ($6f5202a002b4b4fe$var$ids[prefix] || 0) + 1);
}
function $6f5202a002b4b4fe$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $6f5202a002b4b4fe$var$forEach(targets, function(target) {
            target && $6f5202a002b4b4fe$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $6f5202a002b4b4fe$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $6f5202a002b4b4fe$export$d300dc1a2634364b = "mounted";
var $6f5202a002b4b4fe$export$d8dac49b4532735a = "ready";
var $6f5202a002b4b4fe$export$2aa493d7c3275167 = "move";
var $6f5202a002b4b4fe$export$fe5802204b967f0d = "moved";
var $6f5202a002b4b4fe$export$5adb665701eda1ce = "click";
var $6f5202a002b4b4fe$export$92e3eae133acac4c = "active";
var $6f5202a002b4b4fe$export$6bcbb81035c12cea = "inactive";
var $6f5202a002b4b4fe$export$6a5b3445e4066a53 = "visible";
var $6f5202a002b4b4fe$export$8c5c7a21d54563e9 = "hidden";
var $6f5202a002b4b4fe$export$7f4701ac5e05e39f = "refresh";
var $6f5202a002b4b4fe$export$db40ab7c0855fa5c = "updated";
var $6f5202a002b4b4fe$export$7e019dae5103a285 = "resize";
var $6f5202a002b4b4fe$export$d637eba1e9e28482 = "resized";
var $6f5202a002b4b4fe$export$e84bf5065c9087ac = "drag";
var $6f5202a002b4b4fe$export$8e9f636d2c722196 = "dragging";
var $6f5202a002b4b4fe$export$90ea576bd3fdeb60 = "dragged";
var $6f5202a002b4b4fe$export$49801896908b5e33 = "scroll";
var $6f5202a002b4b4fe$export$ff8164bff3202b9 = "scrolled";
var $6f5202a002b4b4fe$export$6cbac5b662a31e1b = "overflow";
var $6f5202a002b4b4fe$export$88c4cf7419e470cd = "destroy";
var $6f5202a002b4b4fe$export$8647f6b043e04e9d = "arrows:mounted";
var $6f5202a002b4b4fe$export$d467f9343b961f75 = "arrows:updated";
var $6f5202a002b4b4fe$export$bf89a4e4349c9778 = "pagination:mounted";
var $6f5202a002b4b4fe$export$eb2019082ed6de0b = "pagination:updated";
var $6f5202a002b4b4fe$export$84015c33508f94ec = "navigation:mounted";
var $6f5202a002b4b4fe$export$23663268a31b79e2 = "autoplay:play";
var $6f5202a002b4b4fe$export$185723258309b608 = "autoplay:playing";
var $6f5202a002b4b4fe$export$16a1e4f3d0368265 = "autoplay:pause";
var $6f5202a002b4b4fe$export$9f64346e17f0ec8e = "lazyload:loaded";
var $6f5202a002b4b4fe$export$6d5af59619d10e6a = "sk";
var $6f5202a002b4b4fe$export$f0af896383d5adff = "sh";
var $6f5202a002b4b4fe$export$28dea85f216954dc = "ei";
function $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $6f5202a002b4b4fe$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $6f5202a002b4b4fe$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $6f5202a002b4b4fe$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $6f5202a002b4b4fe$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($6f5202a002b4b4fe$export$88c4cf7419e470cd, binder.destroy);
    return $6f5202a002b4b4fe$var$assign(binder, {
        bus: bus,
        on: on,
        off: $6f5202a002b4b4fe$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $6f5202a002b4b4fe$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $6f5202a002b4b4fe$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $6f5202a002b4b4fe$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $6f5202a002b4b4fe$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $6f5202a002b4b4fe$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $6f5202a002b4b4fe$var$includes($6f5202a002b4b4fe$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $6f5202a002b4b4fe$export$efff0f5979573c99(func, duration) {
    var interval = $6f5202a002b4b4fe$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $6f5202a002b4b4fe$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $6f5202a002b4b4fe$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $6f5202a002b4b4fe$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $6f5202a002b4b4fe$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($6f5202a002b4b4fe$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $6f5202a002b4b4fe$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $6f5202a002b4b4fe$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($6f5202a002b4b4fe$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $6f5202a002b4b4fe$var$merge(options, reducedMotion) : $6f5202a002b4b4fe$var$omit(options, $6f5202a002b4b4fe$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $6f5202a002b4b4fe$var$merge(options, opts);
        base && $6f5202a002b4b4fe$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($6f5202a002b4b4fe$var$CREATED)) Splide2.emit($6f5202a002b4b4fe$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $6f5202a002b4b4fe$var$ARROW = "Arrow";
var $6f5202a002b4b4fe$var$ARROW_LEFT = $6f5202a002b4b4fe$var$ARROW + "Left";
var $6f5202a002b4b4fe$var$ARROW_RIGHT = $6f5202a002b4b4fe$var$ARROW + "Right";
var $6f5202a002b4b4fe$var$ARROW_UP = $6f5202a002b4b4fe$var$ARROW + "Up";
var $6f5202a002b4b4fe$var$ARROW_DOWN = $6f5202a002b4b4fe$var$ARROW + "Down";
var $6f5202a002b4b4fe$export$373e92e0788ff06e = "ltr";
var $6f5202a002b4b4fe$export$850f7749a2909601 = "rtl";
var $6f5202a002b4b4fe$export$97170d9824b89709 = "ttb";
var $6f5202a002b4b4fe$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $6f5202a002b4b4fe$var$ARROW_UP,
        $6f5202a002b4b4fe$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $6f5202a002b4b4fe$var$ARROW_DOWN,
        $6f5202a002b4b4fe$var$ARROW_LEFT
    ]
};
function $6f5202a002b4b4fe$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $6f5202a002b4b4fe$export$850f7749a2909601 && !axisOnly ? 1 : direction === $6f5202a002b4b4fe$export$97170d9824b89709 ? 0 : -1;
        return $6f5202a002b4b4fe$var$ORIENTATION_MAP[prop] && $6f5202a002b4b4fe$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $6f5202a002b4b4fe$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $6f5202a002b4b4fe$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $6f5202a002b4b4fe$var$ROLE = "role";
var $6f5202a002b4b4fe$var$TAB_INDEX = "tabindex";
var $6f5202a002b4b4fe$var$DISABLED = "disabled";
var $6f5202a002b4b4fe$var$ARIA_PREFIX = "aria-";
var $6f5202a002b4b4fe$var$ARIA_CONTROLS = $6f5202a002b4b4fe$var$ARIA_PREFIX + "controls";
var $6f5202a002b4b4fe$var$ARIA_CURRENT = $6f5202a002b4b4fe$var$ARIA_PREFIX + "current";
var $6f5202a002b4b4fe$var$ARIA_SELECTED = $6f5202a002b4b4fe$var$ARIA_PREFIX + "selected";
var $6f5202a002b4b4fe$var$ARIA_LABEL = $6f5202a002b4b4fe$var$ARIA_PREFIX + "label";
var $6f5202a002b4b4fe$var$ARIA_LABELLEDBY = $6f5202a002b4b4fe$var$ARIA_PREFIX + "labelledby";
var $6f5202a002b4b4fe$var$ARIA_HIDDEN = $6f5202a002b4b4fe$var$ARIA_PREFIX + "hidden";
var $6f5202a002b4b4fe$var$ARIA_ORIENTATION = $6f5202a002b4b4fe$var$ARIA_PREFIX + "orientation";
var $6f5202a002b4b4fe$var$ARIA_ROLEDESCRIPTION = $6f5202a002b4b4fe$var$ARIA_PREFIX + "roledescription";
var $6f5202a002b4b4fe$var$ARIA_LIVE = $6f5202a002b4b4fe$var$ARIA_PREFIX + "live";
var $6f5202a002b4b4fe$var$ARIA_BUSY = $6f5202a002b4b4fe$var$ARIA_PREFIX + "busy";
var $6f5202a002b4b4fe$var$ARIA_ATOMIC = $6f5202a002b4b4fe$var$ARIA_PREFIX + "atomic";
var $6f5202a002b4b4fe$var$ALL_ATTRIBUTES = [
    $6f5202a002b4b4fe$var$ROLE,
    $6f5202a002b4b4fe$var$TAB_INDEX,
    $6f5202a002b4b4fe$var$DISABLED,
    $6f5202a002b4b4fe$var$ARIA_CONTROLS,
    $6f5202a002b4b4fe$var$ARIA_CURRENT,
    $6f5202a002b4b4fe$var$ARIA_LABEL,
    $6f5202a002b4b4fe$var$ARIA_LABELLEDBY,
    $6f5202a002b4b4fe$var$ARIA_HIDDEN,
    $6f5202a002b4b4fe$var$ARIA_ORIENTATION,
    $6f5202a002b4b4fe$var$ARIA_ROLEDESCRIPTION
];
var $6f5202a002b4b4fe$var$CLASS_PREFIX = $6f5202a002b4b4fe$var$PROJECT_CODE + "__";
var $6f5202a002b4b4fe$var$STATUS_CLASS_PREFIX = "is-";
var $6f5202a002b4b4fe$export$93b21159ad85c843 = $6f5202a002b4b4fe$var$PROJECT_CODE;
var $6f5202a002b4b4fe$export$7738b09ac0a98952 = $6f5202a002b4b4fe$var$CLASS_PREFIX + "track";
var $6f5202a002b4b4fe$export$19cc2a5451235cae = $6f5202a002b4b4fe$var$CLASS_PREFIX + "list";
var $6f5202a002b4b4fe$export$8d922915837a38d3 = $6f5202a002b4b4fe$var$CLASS_PREFIX + "slide";
var $6f5202a002b4b4fe$export$2c1ba4a4f1aa4947 = $6f5202a002b4b4fe$export$8d922915837a38d3 + "--clone";
var $6f5202a002b4b4fe$export$e9ba7e444ba60a12 = $6f5202a002b4b4fe$export$8d922915837a38d3 + "__container";
var $6f5202a002b4b4fe$export$a26cbd955fecf11e = $6f5202a002b4b4fe$var$CLASS_PREFIX + "arrows";
var $6f5202a002b4b4fe$export$516e7d18e13a2dca = $6f5202a002b4b4fe$var$CLASS_PREFIX + "arrow";
var $6f5202a002b4b4fe$export$58ea3db24c33b76 = $6f5202a002b4b4fe$export$516e7d18e13a2dca + "--prev";
var $6f5202a002b4b4fe$export$4885afd7098a65c2 = $6f5202a002b4b4fe$export$516e7d18e13a2dca + "--next";
var $6f5202a002b4b4fe$export$cbf8e5a0ab95eda3 = $6f5202a002b4b4fe$var$CLASS_PREFIX + "pagination";
var $6f5202a002b4b4fe$export$52f2cca6a5eee805 = $6f5202a002b4b4fe$export$cbf8e5a0ab95eda3 + "__page";
var $6f5202a002b4b4fe$export$4c82dc32b1c4ace5 = $6f5202a002b4b4fe$var$CLASS_PREFIX + "progress";
var $6f5202a002b4b4fe$export$2c9b091c749f4409 = $6f5202a002b4b4fe$export$4c82dc32b1c4ace5 + "__bar";
var $6f5202a002b4b4fe$export$a29701deef84b825 = $6f5202a002b4b4fe$var$CLASS_PREFIX + "toggle";
var $6f5202a002b4b4fe$export$d9d247d51b430dbb = $6f5202a002b4b4fe$export$a29701deef84b825 + "__play";
var $6f5202a002b4b4fe$export$3529f201a419925b = $6f5202a002b4b4fe$export$a29701deef84b825 + "__pause";
var $6f5202a002b4b4fe$export$3e5381ee3fab8374 = $6f5202a002b4b4fe$var$CLASS_PREFIX + "spinner";
var $6f5202a002b4b4fe$export$bb78d7c200da8960 = $6f5202a002b4b4fe$var$CLASS_PREFIX + "sr";
var $6f5202a002b4b4fe$export$7761661e2d5b9388 = $6f5202a002b4b4fe$var$STATUS_CLASS_PREFIX + "initialized";
var $6f5202a002b4b4fe$export$72d36ecf3758cb4b = $6f5202a002b4b4fe$var$STATUS_CLASS_PREFIX + "active";
var $6f5202a002b4b4fe$export$e423ac4972f5e196 = $6f5202a002b4b4fe$var$STATUS_CLASS_PREFIX + "prev";
var $6f5202a002b4b4fe$export$457a2d20827a2779 = $6f5202a002b4b4fe$var$STATUS_CLASS_PREFIX + "next";
var $6f5202a002b4b4fe$export$53ca4621bbab9a = $6f5202a002b4b4fe$var$STATUS_CLASS_PREFIX + "visible";
var $6f5202a002b4b4fe$export$d22ec4ccb7996ba2 = $6f5202a002b4b4fe$var$STATUS_CLASS_PREFIX + "loading";
var $6f5202a002b4b4fe$export$b6f202a162a09100 = $6f5202a002b4b4fe$var$STATUS_CLASS_PREFIX + "focus-in";
var $6f5202a002b4b4fe$export$cd908cd1dd625e29 = $6f5202a002b4b4fe$var$STATUS_CLASS_PREFIX + "overflow";
var $6f5202a002b4b4fe$export$49f9eaea10ebf193 = [
    $6f5202a002b4b4fe$export$72d36ecf3758cb4b,
    $6f5202a002b4b4fe$export$53ca4621bbab9a,
    $6f5202a002b4b4fe$export$e423ac4972f5e196,
    $6f5202a002b4b4fe$export$457a2d20827a2779,
    $6f5202a002b4b4fe$export$d22ec4ccb7996ba2,
    $6f5202a002b4b4fe$export$b6f202a162a09100,
    $6f5202a002b4b4fe$export$cd908cd1dd625e29
];
var $6f5202a002b4b4fe$export$ba41d43e4a419565 = {
    slide: $6f5202a002b4b4fe$export$8d922915837a38d3,
    clone: $6f5202a002b4b4fe$export$2c1ba4a4f1aa4947,
    arrows: $6f5202a002b4b4fe$export$a26cbd955fecf11e,
    arrow: $6f5202a002b4b4fe$export$516e7d18e13a2dca,
    prev: $6f5202a002b4b4fe$export$58ea3db24c33b76,
    next: $6f5202a002b4b4fe$export$4885afd7098a65c2,
    pagination: $6f5202a002b4b4fe$export$cbf8e5a0ab95eda3,
    page: $6f5202a002b4b4fe$export$52f2cca6a5eee805,
    spinner: $6f5202a002b4b4fe$export$3e5381ee3fab8374
};
function $6f5202a002b4b4fe$var$closest(from, selector) {
    if ($6f5202a002b4b4fe$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($6f5202a002b4b4fe$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $6f5202a002b4b4fe$var$FRICTION = 5;
var $6f5202a002b4b4fe$var$LOG_INTERVAL = 200;
var $6f5202a002b4b4fe$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $6f5202a002b4b4fe$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $6f5202a002b4b4fe$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $6f5202a002b4b4fe$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($6f5202a002b4b4fe$export$7f4701ac5e05e39f, destroy);
        on($6f5202a002b4b4fe$export$7f4701ac5e05e39f, setup);
        on($6f5202a002b4b4fe$export$db40ab7c0855fa5c, update);
        bind(document, $6f5202a002b4b4fe$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $6f5202a002b4b4fe$var$toggleClass(root, $6f5202a002b4b4fe$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $6f5202a002b4b4fe$var$ALL_ATTRIBUTES.concat("style");
        $6f5202a002b4b4fe$var$empty(slides);
        $6f5202a002b4b4fe$var$removeClass(root, rootClasses);
        $6f5202a002b4b4fe$var$removeClass(track, trackClasses);
        $6f5202a002b4b4fe$var$removeAttribute([
            track,
            list
        ], attrs);
        $6f5202a002b4b4fe$var$removeAttribute(root, completely ? attrs : [
            "style",
            $6f5202a002b4b4fe$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $6f5202a002b4b4fe$var$removeClass(root, rootClasses);
        $6f5202a002b4b4fe$var$removeClass(track, trackClasses);
        rootClasses = getClasses($6f5202a002b4b4fe$export$93b21159ad85c843);
        trackClasses = getClasses($6f5202a002b4b4fe$export$7738b09ac0a98952);
        $6f5202a002b4b4fe$var$addClass(root, rootClasses);
        $6f5202a002b4b4fe$var$addClass(track, trackClasses);
        $6f5202a002b4b4fe$var$setAttribute(root, $6f5202a002b4b4fe$var$ARIA_LABEL, options.label);
        $6f5202a002b4b4fe$var$setAttribute(root, $6f5202a002b4b4fe$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $6f5202a002b4b4fe$export$7738b09ac0a98952);
        list = $6f5202a002b4b4fe$var$child(track, "." + $6f5202a002b4b4fe$export$19cc2a5451235cae);
        $6f5202a002b4b4fe$var$assert(track && list, "A track/list element is missing.");
        $6f5202a002b4b4fe$var$push(slides, $6f5202a002b4b4fe$var$children(list, "." + $6f5202a002b4b4fe$export$8d922915837a38d3 + ":not(." + $6f5202a002b4b4fe$export$2c1ba4a4f1aa4947 + ")"));
        $6f5202a002b4b4fe$var$forOwn({
            arrows: $6f5202a002b4b4fe$export$a26cbd955fecf11e,
            pagination: $6f5202a002b4b4fe$export$cbf8e5a0ab95eda3,
            prev: $6f5202a002b4b4fe$export$58ea3db24c33b76,
            next: $6f5202a002b4b4fe$export$4885afd7098a65c2,
            bar: $6f5202a002b4b4fe$export$2c9b091c749f4409,
            toggle: $6f5202a002b4b4fe$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $6f5202a002b4b4fe$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $6f5202a002b4b4fe$var$uniqueId($6f5202a002b4b4fe$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$6f5202a002b4b4fe$var$getAttribute(root, $6f5202a002b4b4fe$var$ROLE) && root.tagName !== "SECTION" && role) $6f5202a002b4b4fe$var$setAttribute(root, $6f5202a002b4b4fe$var$ROLE, role);
        $6f5202a002b4b4fe$var$setAttribute(root, $6f5202a002b4b4fe$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $6f5202a002b4b4fe$var$setAttribute(list, $6f5202a002b4b4fe$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $6f5202a002b4b4fe$var$query(root, selector);
        return elm && $6f5202a002b4b4fe$var$closest(elm, "." + $6f5202a002b4b4fe$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $6f5202a002b4b4fe$export$93b21159ad85c843 && $6f5202a002b4b4fe$export$72d36ecf3758cb4b
        ];
    }
    return $6f5202a002b4b4fe$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $6f5202a002b4b4fe$export$e5a58a5ee5b54c22 = "slide";
var $6f5202a002b4b4fe$export$f42383286ed1223d = "loop";
var $6f5202a002b4b4fe$export$742b62a5690c060 = "fade";
function $6f5202a002b4b4fe$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $6f5202a002b4b4fe$var$getAttribute(slide, "style");
    var label = $6f5202a002b4b4fe$var$getAttribute(slide, $6f5202a002b4b4fe$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $6f5202a002b4b4fe$var$child(slide, "." + $6f5202a002b4b4fe$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $6f5202a002b4b4fe$var$pad(index + 1);
            $6f5202a002b4b4fe$var$setAttribute(slide, $6f5202a002b4b4fe$var$ROLE, pagination ? "tabpanel" : "group");
            $6f5202a002b4b4fe$var$setAttribute(slide, $6f5202a002b4b4fe$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $6f5202a002b4b4fe$var$setAttribute(slide, $6f5202a002b4b4fe$var$ARIA_LABEL, label || $6f5202a002b4b4fe$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $6f5202a002b4b4fe$var$apply(emit, $6f5202a002b4b4fe$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $6f5202a002b4b4fe$var$apply(emit, $6f5202a002b4b4fe$export$6d5af59619d10e6a, self));
        on([
            $6f5202a002b4b4fe$export$fe5802204b967f0d,
            $6f5202a002b4b4fe$export$f0af896383d5adff,
            $6f5202a002b4b4fe$export$ff8164bff3202b9
        ], update);
        on($6f5202a002b4b4fe$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($6f5202a002b4b4fe$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $6f5202a002b4b4fe$var$removeClass(slide, $6f5202a002b4b4fe$export$49f9eaea10ebf193);
        $6f5202a002b4b4fe$var$removeAttribute(slide, $6f5202a002b4b4fe$var$ALL_ATTRIBUTES);
        $6f5202a002b4b4fe$var$setAttribute(slide, "style", styles);
        $6f5202a002b4b4fe$var$setAttribute(slide, $6f5202a002b4b4fe$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $6f5202a002b4b4fe$var$setAttribute(slide, $6f5202a002b4b4fe$var$ARIA_LABEL, $6f5202a002b4b4fe$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $6f5202a002b4b4fe$var$setAttribute(slide, $6f5202a002b4b4fe$var$ARIA_CONTROLS, controls);
        $6f5202a002b4b4fe$var$setAttribute(slide, $6f5202a002b4b4fe$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $6f5202a002b4b4fe$var$removeAttribute(slide, $6f5202a002b4b4fe$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $6f5202a002b4b4fe$var$toggleClass(slide, $6f5202a002b4b4fe$export$e423ac4972f5e196, index === curr - 1);
            $6f5202a002b4b4fe$var$toggleClass(slide, $6f5202a002b4b4fe$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $6f5202a002b4b4fe$var$hasClass(slide, $6f5202a002b4b4fe$export$72d36ecf3758cb4b)) {
            $6f5202a002b4b4fe$var$toggleClass(slide, $6f5202a002b4b4fe$export$72d36ecf3758cb4b, active);
            $6f5202a002b4b4fe$var$setAttribute(slide, $6f5202a002b4b4fe$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $6f5202a002b4b4fe$export$92e3eae133acac4c : $6f5202a002b4b4fe$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $6f5202a002b4b4fe$var$MOVING,
            $6f5202a002b4b4fe$var$SCROLLING
        ])) $6f5202a002b4b4fe$var$setAttribute(slide, $6f5202a002b4b4fe$var$ARIA_HIDDEN, hidden || "");
        $6f5202a002b4b4fe$var$setAttribute($6f5202a002b4b4fe$var$queryAll(slide, options.focusableNodes || ""), $6f5202a002b4b4fe$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $6f5202a002b4b4fe$var$setAttribute(slide, $6f5202a002b4b4fe$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $6f5202a002b4b4fe$var$hasClass(slide, $6f5202a002b4b4fe$export$53ca4621bbab9a)) {
            $6f5202a002b4b4fe$var$toggleClass(slide, $6f5202a002b4b4fe$export$53ca4621bbab9a, visible);
            emit(visible ? $6f5202a002b4b4fe$export$6a5b3445e4066a53 : $6f5202a002b4b4fe$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $6f5202a002b4b4fe$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $6f5202a002b4b4fe$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($6f5202a002b4b4fe$export$742b62a5690c060)) return isActive();
        var trackRect = $6f5202a002b4b4fe$var$rect(Components.Elements.track);
        var slideRect = $6f5202a002b4b4fe$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $6f5202a002b4b4fe$var$floor(trackRect[left]) <= $6f5202a002b4b4fe$var$ceil(slideRect[left]) && $6f5202a002b4b4fe$var$floor(slideRect[right]) <= $6f5202a002b4b4fe$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $6f5202a002b4b4fe$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($6f5202a002b4b4fe$export$f42383286ed1223d))) diff = $6f5202a002b4b4fe$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $6f5202a002b4b4fe$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($6f5202a002b4b4fe$export$7f4701ac5e05e39f, destroy);
        on($6f5202a002b4b4fe$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $6f5202a002b4b4fe$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $6f5202a002b4b4fe$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $6f5202a002b4b4fe$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $6f5202a002b4b4fe$var$forEach(items, function(slide) {
            if ($6f5202a002b4b4fe$var$isString(slide)) slide = $6f5202a002b4b4fe$var$parseHtml(slide);
            if ($6f5202a002b4b4fe$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $6f5202a002b4b4fe$var$before(slide, ref) : $6f5202a002b4b4fe$var$append(list, slide);
                $6f5202a002b4b4fe$var$addClass(slide, options.classes.slide);
                observeImages(slide, $6f5202a002b4b4fe$var$apply(emit, $6f5202a002b4b4fe$export$7e019dae5103a285));
            }
        });
        emit($6f5202a002b4b4fe$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $6f5202a002b4b4fe$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($6f5202a002b4b4fe$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($6f5202a002b4b4fe$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $6f5202a002b4b4fe$var$isString(matcher) ? $6f5202a002b4b4fe$var$matches(Slide2.slide, matcher) : $6f5202a002b4b4fe$var$includes($6f5202a002b4b4fe$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $6f5202a002b4b4fe$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $6f5202a002b4b4fe$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $6f5202a002b4b4fe$export$efff0f5979573c99($6f5202a002b4b4fe$var$apply(emit, $6f5202a002b4b4fe$export$7e019dae5103a285)));
        on([
            $6f5202a002b4b4fe$export$db40ab7c0855fa5c,
            $6f5202a002b4b4fe$export$7f4701ac5e05e39f
        ], init);
        on($6f5202a002b4b4fe$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $6f5202a002b4b4fe$export$97170d9824b89709;
        $6f5202a002b4b4fe$var$style(root, "maxWidth", $6f5202a002b4b4fe$var$unit(options.width));
        $6f5202a002b4b4fe$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $6f5202a002b4b4fe$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $6f5202a002b4b4fe$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $6f5202a002b4b4fe$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $6f5202a002b4b4fe$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($6f5202a002b4b4fe$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $6f5202a002b4b4fe$var$toggleClass(root, $6f5202a002b4b4fe$export$cd908cd1dd625e29, overflow);
                emit($6f5202a002b4b4fe$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $6f5202a002b4b4fe$var$unit(padding[prop] || ($6f5202a002b4b4fe$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $6f5202a002b4b4fe$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $6f5202a002b4b4fe$var$unit(options.height || $6f5202a002b4b4fe$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $6f5202a002b4b4fe$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $6f5202a002b4b4fe$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $6f5202a002b4b4fe$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $6f5202a002b4b4fe$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $6f5202a002b4b4fe$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $6f5202a002b4b4fe$var$rect(Slide.slide)[resolve("right")];
            var left = $6f5202a002b4b4fe$var$rect(list)[resolve("left")];
            return $6f5202a002b4b4fe$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($6f5202a002b4b4fe$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($6f5202a002b4b4fe$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($6f5202a002b4b4fe$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $6f5202a002b4b4fe$var$MULTIPLIER = 2;
function $6f5202a002b4b4fe$var$Clones(Splide2, Components2, options) {
    var event = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($6f5202a002b4b4fe$export$7f4701ac5e05e39f, remount);
        on([
            $6f5202a002b4b4fe$export$db40ab7c0855fa5c,
            $6f5202a002b4b4fe$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $6f5202a002b4b4fe$var$remove(clones);
        $6f5202a002b4b4fe$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($6f5202a002b4b4fe$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$6f5202a002b4b4fe$var$push(slides, slides);
            $6f5202a002b4b4fe$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $6f5202a002b4b4fe$var$before(clone, slides[0].slide) : $6f5202a002b4b4fe$var$append(Elements.list, clone);
                $6f5202a002b4b4fe$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $6f5202a002b4b4fe$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $6f5202a002b4b4fe$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($6f5202a002b4b4fe$export$f42383286ed1223d)) clones2 = 0;
        else if ($6f5202a002b4b4fe$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $6f5202a002b4b4fe$var$ceil($6f5202a002b4b4fe$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $6f5202a002b4b4fe$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $6f5202a002b4b4fe$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $6f5202a002b4b4fe$export$d300dc1a2634364b,
            $6f5202a002b4b4fe$export$d637eba1e9e28482,
            $6f5202a002b4b4fe$export$db40ab7c0855fa5c,
            $6f5202a002b4b4fe$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($6f5202a002b4b4fe$var$MOVING);
        emit($6f5202a002b4b4fe$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($6f5202a002b4b4fe$var$IDLE);
            emit($6f5202a002b4b4fe$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($6f5202a002b4b4fe$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $6f5202a002b4b4fe$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($6f5202a002b4b4fe$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($6f5202a002b4b4fe$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($6f5202a002b4b4fe$var$ceil($6f5202a002b4b4fe$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $6f5202a002b4b4fe$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $6f5202a002b4b4fe$var$rect(list)[left] - $6f5202a002b4b4fe$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($6f5202a002b4b4fe$export$e5a58a5ee5b54c22)) position = $6f5202a002b4b4fe$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $6f5202a002b4b4fe$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $6f5202a002b4b4fe$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $6f5202a002b4b4fe$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($6f5202a002b4b4fe$export$f42383286ed1223d);
    var isSlide = Splide2.is($6f5202a002b4b4fe$export$e5a58a5ee5b54c22);
    var getNext = $6f5202a002b4b4fe$var$apply(getAdjacent, false);
    var getPrev = $6f5202a002b4b4fe$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $6f5202a002b4b4fe$export$db40ab7c0855fa5c,
            $6f5202a002b4b4fe$export$7f4701ac5e05e39f,
            $6f5202a002b4b4fe$export$28dea85f216954dc
        ], init);
        on($6f5202a002b4b4fe$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $6f5202a002b4b4fe$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($6f5202a002b4b4fe$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $6f5202a002b4b4fe$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($6f5202a002b4b4fe$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $6f5202a002b4b4fe$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$6f5202a002b4b4fe$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($6f5202a002b4b4fe$var$between(0, dest, from, true) || $6f5202a002b4b4fe$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $6f5202a002b4b4fe$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $6f5202a002b4b4fe$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $6f5202a002b4b4fe$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $6f5202a002b4b4fe$var$min(index, endIndex) : $6f5202a002b4b4fe$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $6f5202a002b4b4fe$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$6f5202a002b4b4fe$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $6f5202a002b4b4fe$var$MOVING,
            $6f5202a002b4b4fe$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $6f5202a002b4b4fe$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $6f5202a002b4b4fe$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $6f5202a002b4b4fe$var$SIZE = 40;
function $6f5202a002b4b4fe$var$Arrows(Splide2, Components2, options) {
    var event = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($6f5202a002b4b4fe$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $6f5202a002b4b4fe$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $6f5202a002b4b4fe$var$display(wrapper, enabled ? "" : "none");
            $6f5202a002b4b4fe$var$addClass(wrapper, wrapperClasses = $6f5202a002b4b4fe$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $6f5202a002b4b4fe$var$setAttribute([
                    prev,
                    next
                ], $6f5202a002b4b4fe$var$ARIA_CONTROLS, track.id);
                emit($6f5202a002b4b4fe$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $6f5202a002b4b4fe$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $6f5202a002b4b4fe$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $6f5202a002b4b4fe$var$removeAttribute([
            prev,
            next
        ], $6f5202a002b4b4fe$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $6f5202a002b4b4fe$export$d300dc1a2634364b,
            $6f5202a002b4b4fe$export$fe5802204b967f0d,
            $6f5202a002b4b4fe$export$7f4701ac5e05e39f,
            $6f5202a002b4b4fe$export$ff8164bff3202b9,
            $6f5202a002b4b4fe$export$28dea85f216954dc
        ], update);
        bind(next, "click", $6f5202a002b4b4fe$var$apply(go, ">"));
        bind(prev, "click", $6f5202a002b4b4fe$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $6f5202a002b4b4fe$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $6f5202a002b4b4fe$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $6f5202a002b4b4fe$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $6f5202a002b4b4fe$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $6f5202a002b4b4fe$var$SIZE + " " + $6f5202a002b4b4fe$var$SIZE + '" width="' + $6f5202a002b4b4fe$var$SIZE + '" height="' + $6f5202a002b4b4fe$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $6f5202a002b4b4fe$var$PATH) + '" />';
        return $6f5202a002b4b4fe$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $6f5202a002b4b4fe$var$setAttribute(prev, $6f5202a002b4b4fe$var$ARIA_LABEL, prevLabel);
            $6f5202a002b4b4fe$var$setAttribute(next, $6f5202a002b4b4fe$var$ARIA_LABEL, nextLabel);
            emit($6f5202a002b4b4fe$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $6f5202a002b4b4fe$var$INTERVAL_DATA_ATTRIBUTE = $6f5202a002b4b4fe$var$DATA_ATTRIBUTE + "-interval";
function $6f5202a002b4b4fe$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $6f5202a002b4b4fe$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $6f5202a002b4b4fe$var$setAttribute(toggle, $6f5202a002b4b4fe$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $6f5202a002b4b4fe$export$2aa493d7c3275167,
            $6f5202a002b4b4fe$export$49801896908b5e33,
            $6f5202a002b4b4fe$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($6f5202a002b4b4fe$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($6f5202a002b4b4fe$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($6f5202a002b4b4fe$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $6f5202a002b4b4fe$var$toggleClass(toggle, $6f5202a002b4b4fe$export$72d36ecf3758cb4b, !stopped);
            $6f5202a002b4b4fe$var$setAttribute(toggle, $6f5202a002b4b4fe$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $6f5202a002b4b4fe$var$style(bar, "width", rate * 100 + "%");
        emit($6f5202a002b4b4fe$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$6f5202a002b4b4fe$var$getAttribute(Slide.slide, $6f5202a002b4b4fe$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $6f5202a002b4b4fe$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($6f5202a002b4b4fe$export$9f64346e17f0ec8e, $6f5202a002b4b4fe$var$apply(toggle, true));
            on([
                $6f5202a002b4b4fe$export$d300dc1a2634364b,
                $6f5202a002b4b4fe$export$db40ab7c0855fa5c,
                $6f5202a002b4b4fe$export$7f4701ac5e05e39f
            ], $6f5202a002b4b4fe$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $6f5202a002b4b4fe$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $6f5202a002b4b4fe$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $6f5202a002b4b4fe$var$apply(cover, false)
    };
}
var $6f5202a002b4b4fe$var$BOUNCE_DIFF_THRESHOLD = 10;
var $6f5202a002b4b4fe$var$BOUNCE_DURATION = 600;
var $6f5202a002b4b4fe$var$FRICTION_FACTOR = 0.6;
var $6f5202a002b4b4fe$var$BASE_VELOCITY = 1.5;
var $6f5202a002b4b4fe$var$MIN_DURATION = 800;
function $6f5202a002b4b4fe$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($6f5202a002b4b4fe$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($6f5202a002b4b4fe$export$2aa493d7c3275167, clear);
        on([
            $6f5202a002b4b4fe$export$db40ab7c0855fa5c,
            $6f5202a002b4b4fe$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $6f5202a002b4b4fe$var$sign(destination) * size * $6f5202a002b4b4fe$var$floor($6f5202a002b4b4fe$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $6f5202a002b4b4fe$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $6f5202a002b4b4fe$var$max($6f5202a002b4b4fe$var$abs(destination - from) / $6f5202a002b4b4fe$var$BASE_VELOCITY, $6f5202a002b4b4fe$var$MIN_DURATION);
        callback = onScrolled;
        interval = $6f5202a002b4b4fe$export$46ad21b25b6dccf0(duration, onEnd, $6f5202a002b4b4fe$var$apply(update, from, destination, noConstrain), 1);
        set($6f5202a002b4b4fe$var$SCROLLING);
        emit($6f5202a002b4b4fe$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($6f5202a002b4b4fe$var$IDLE);
        callback && callback();
        emit($6f5202a002b4b4fe$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $6f5202a002b4b4fe$var$FRICTION_FACTOR;
            if ($6f5202a002b4b4fe$var$abs(diff) < $6f5202a002b4b4fe$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $6f5202a002b4b4fe$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $6f5202a002b4b4fe$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $6f5202a002b4b4fe$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $6f5202a002b4b4fe$var$POINTER_MOVE_EVENTS, $6f5202a002b4b4fe$var$noop, $6f5202a002b4b4fe$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $6f5202a002b4b4fe$var$POINTER_UP_EVENTS, $6f5202a002b4b4fe$var$noop, $6f5202a002b4b4fe$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $6f5202a002b4b4fe$var$POINTER_DOWN_EVENTS, onPointerDown, $6f5202a002b4b4fe$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $6f5202a002b4b4fe$var$prevent);
        on([
            $6f5202a002b4b4fe$export$d300dc1a2634364b,
            $6f5202a002b4b4fe$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $6f5202a002b4b4fe$var$MOVING,
                        $6f5202a002b4b4fe$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $6f5202a002b4b4fe$var$POINTER_MOVE_EVENTS, onPointerMove, $6f5202a002b4b4fe$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $6f5202a002b4b4fe$var$POINTER_UP_EVENTS, onPointerUp, $6f5202a002b4b4fe$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $6f5202a002b4b4fe$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($6f5202a002b4b4fe$var$DRAGGING)) {
            state.set($6f5202a002b4b4fe$var$DRAGGING);
            emit($6f5202a002b4b4fe$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $6f5202a002b4b4fe$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($6f5202a002b4b4fe$export$8e9f636d2c722196);
                $6f5202a002b4b4fe$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $6f5202a002b4b4fe$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($6f5202a002b4b4fe$var$DRAGGING)) {
            state.set($6f5202a002b4b4fe$var$IDLE);
            emit($6f5202a002b4b4fe$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $6f5202a002b4b4fe$var$prevent(e);
        }
        unbind(target, $6f5202a002b4b4fe$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $6f5202a002b4b4fe$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $6f5202a002b4b4fe$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($6f5202a002b4b4fe$export$742b62a5690c060)) Controller.go(orient($6f5202a002b4b4fe$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($6f5202a002b4b4fe$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $6f5202a002b4b4fe$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $6f5202a002b4b4fe$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $6f5202a002b4b4fe$var$abs(diffCoord(e)) > $6f5202a002b4b4fe$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($6f5202a002b4b4fe$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $6f5202a002b4b4fe$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $6f5202a002b4b4fe$var$sign(velocity) * $6f5202a002b4b4fe$var$min($6f5202a002b4b4fe$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $6f5202a002b4b4fe$var$timeOf(e) - $6f5202a002b4b4fe$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($6f5202a002b4b4fe$export$e5a58a5ee5b54c22) ? $6f5202a002b4b4fe$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$6f5202a002b4b4fe$var$matches(target2, "." + $6f5202a002b4b4fe$export$52f2cca6a5eee805 + ", ." + $6f5202a002b4b4fe$export$516e7d18e13a2dca) && (!noDrag || !$6f5202a002b4b4fe$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $6f5202a002b4b4fe$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $6f5202a002b4b4fe$var$ARROW_RIGHT,
    Left: $6f5202a002b4b4fe$var$ARROW_LEFT,
    Up: $6f5202a002b4b4fe$var$ARROW_UP,
    Down: $6f5202a002b4b4fe$var$ARROW_DOWN
};
function $6f5202a002b4b4fe$var$normalizeKey(key) {
    key = $6f5202a002b4b4fe$var$isString(key) ? key : key.key;
    return $6f5202a002b4b4fe$var$NORMALIZATION_MAP[key] || key;
}
var $6f5202a002b4b4fe$var$KEYBOARD_EVENT = "keydown";
function $6f5202a002b4b4fe$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($6f5202a002b4b4fe$export$db40ab7c0855fa5c, destroy);
        on($6f5202a002b4b4fe$export$db40ab7c0855fa5c, init);
        on($6f5202a002b4b4fe$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $6f5202a002b4b4fe$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $6f5202a002b4b4fe$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $6f5202a002b4b4fe$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $6f5202a002b4b4fe$var$normalizeKey(e);
            if (key === resolve($6f5202a002b4b4fe$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($6f5202a002b4b4fe$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $6f5202a002b4b4fe$var$SRC_DATA_ATTRIBUTE = $6f5202a002b4b4fe$var$DATA_ATTRIBUTE + "-lazy";
var $6f5202a002b4b4fe$var$SRCSET_DATA_ATTRIBUTE = $6f5202a002b4b4fe$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $6f5202a002b4b4fe$var$IMAGE_SELECTOR = "[" + $6f5202a002b4b4fe$var$SRC_DATA_ATTRIBUTE + "], [" + $6f5202a002b4b4fe$var$SRCSET_DATA_ATTRIBUTE + "]";
function $6f5202a002b4b4fe$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $6f5202a002b4b4fe$export$fe5802204b967f0d,
        $6f5202a002b4b4fe$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($6f5202a002b4b4fe$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $6f5202a002b4b4fe$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $6f5202a002b4b4fe$var$queryAll(Slide.slide, $6f5202a002b4b4fe$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $6f5202a002b4b4fe$var$getAttribute(img, $6f5202a002b4b4fe$var$SRC_DATA_ATTRIBUTE);
                var srcset = $6f5202a002b4b4fe$var$getAttribute(img, $6f5202a002b4b4fe$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $6f5202a002b4b4fe$var$child(parent, "." + className) || $6f5202a002b4b4fe$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $6f5202a002b4b4fe$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $6f5202a002b4b4fe$var$addClass(data[1].slide, $6f5202a002b4b4fe$export$d22ec4ccb7996ba2);
        bind(img, "load error", $6f5202a002b4b4fe$var$apply(onLoad, data));
        $6f5202a002b4b4fe$var$setAttribute(img, "src", $6f5202a002b4b4fe$var$getAttribute(img, $6f5202a002b4b4fe$var$SRC_DATA_ATTRIBUTE));
        $6f5202a002b4b4fe$var$setAttribute(img, "srcset", $6f5202a002b4b4fe$var$getAttribute(img, $6f5202a002b4b4fe$var$SRCSET_DATA_ATTRIBUTE));
        $6f5202a002b4b4fe$var$removeAttribute(img, $6f5202a002b4b4fe$var$SRC_DATA_ATTRIBUTE);
        $6f5202a002b4b4fe$var$removeAttribute(img, $6f5202a002b4b4fe$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $6f5202a002b4b4fe$var$removeClass(Slide.slide, $6f5202a002b4b4fe$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $6f5202a002b4b4fe$var$remove(data[2]);
            $6f5202a002b4b4fe$var$display(img, "");
            emit($6f5202a002b4b4fe$export$9f64346e17f0ec8e, img, Slide);
            emit($6f5202a002b4b4fe$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $6f5202a002b4b4fe$var$apply($6f5202a002b4b4fe$var$empty, entries),
        check: check
    };
}
function $6f5202a002b4b4fe$var$Pagination(Splide2, Components2, options) {
    var event = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $6f5202a002b4b4fe$export$db40ab7c0855fa5c,
            $6f5202a002b4b4fe$export$7f4701ac5e05e39f,
            $6f5202a002b4b4fe$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $6f5202a002b4b4fe$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $6f5202a002b4b4fe$export$2aa493d7c3275167,
                $6f5202a002b4b4fe$export$49801896908b5e33,
                $6f5202a002b4b4fe$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($6f5202a002b4b4fe$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $6f5202a002b4b4fe$var$remove(placeholder ? $6f5202a002b4b4fe$var$slice(list.children) : list);
            $6f5202a002b4b4fe$var$removeClass(list, paginationClasses);
            $6f5202a002b4b4fe$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $6f5202a002b4b4fe$var$ceil(length / perPage);
        list = placeholder || $6f5202a002b4b4fe$var$create("ul", classes.pagination, Elements.track.parentElement);
        $6f5202a002b4b4fe$var$addClass(list, paginationClasses = $6f5202a002b4b4fe$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $6f5202a002b4b4fe$var$setAttribute(list, $6f5202a002b4b4fe$var$ROLE, "tablist");
        $6f5202a002b4b4fe$var$setAttribute(list, $6f5202a002b4b4fe$var$ARIA_LABEL, i18n.select);
        $6f5202a002b4b4fe$var$setAttribute(list, $6f5202a002b4b4fe$var$ARIA_ORIENTATION, getDirection() === $6f5202a002b4b4fe$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $6f5202a002b4b4fe$var$create("li", null, list);
            var button = $6f5202a002b4b4fe$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $6f5202a002b4b4fe$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $6f5202a002b4b4fe$var$apply(onKeydown, i));
            $6f5202a002b4b4fe$var$setAttribute(li, $6f5202a002b4b4fe$var$ROLE, "presentation");
            $6f5202a002b4b4fe$var$setAttribute(button, $6f5202a002b4b4fe$var$ROLE, "tab");
            $6f5202a002b4b4fe$var$setAttribute(button, $6f5202a002b4b4fe$var$ARIA_CONTROLS, controls.join(" "));
            $6f5202a002b4b4fe$var$setAttribute(button, $6f5202a002b4b4fe$var$ARIA_LABEL, $6f5202a002b4b4fe$var$format(text, i + 1));
            $6f5202a002b4b4fe$var$setAttribute(button, $6f5202a002b4b4fe$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $6f5202a002b4b4fe$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($6f5202a002b4b4fe$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($6f5202a002b4b4fe$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $6f5202a002b4b4fe$var$focus(item.button);
            go(">" + nextPage);
            $6f5202a002b4b4fe$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $6f5202a002b4b4fe$var$removeClass(button, $6f5202a002b4b4fe$export$72d36ecf3758cb4b);
            $6f5202a002b4b4fe$var$removeAttribute(button, $6f5202a002b4b4fe$var$ARIA_SELECTED);
            $6f5202a002b4b4fe$var$setAttribute(button, $6f5202a002b4b4fe$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $6f5202a002b4b4fe$var$addClass(_button, $6f5202a002b4b4fe$export$72d36ecf3758cb4b);
            $6f5202a002b4b4fe$var$setAttribute(_button, $6f5202a002b4b4fe$var$ARIA_SELECTED, true);
            $6f5202a002b4b4fe$var$setAttribute(_button, $6f5202a002b4b4fe$var$TAB_INDEX, "");
        }
        emit($6f5202a002b4b4fe$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $6f5202a002b4b4fe$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $6f5202a002b4b4fe$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $6f5202a002b4b4fe$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $6f5202a002b4b4fe$export$f188226459c8a3ff(splide);
        event.on($6f5202a002b4b4fe$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($6f5202a002b4b4fe$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($6f5202a002b4b4fe$export$5adb665701eda1ce, onClick);
        on($6f5202a002b4b4fe$export$6d5af59619d10e6a, onKeydown);
        on([
            $6f5202a002b4b4fe$export$d300dc1a2634364b,
            $6f5202a002b4b4fe$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($6f5202a002b4b4fe$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $6f5202a002b4b4fe$var$setAttribute(Components2.Elements.list, $6f5202a002b4b4fe$var$ARIA_ORIENTATION, options.direction === $6f5202a002b4b4fe$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($6f5202a002b4b4fe$var$includes($6f5202a002b4b4fe$var$TRIGGER_KEYS, $6f5202a002b4b4fe$var$normalizeKey(e))) {
            onClick(Slide);
            $6f5202a002b4b4fe$var$prevent(e);
        }
    }
    return {
        setup: $6f5202a002b4b4fe$var$apply(Components2.Media.set, {
            slideFocus: $6f5202a002b4b4fe$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $6f5202a002b4b4fe$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $6f5202a002b4b4fe$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $6f5202a002b4b4fe$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($6f5202a002b4b4fe$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $6f5202a002b4b4fe$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($6f5202a002b4b4fe$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $6f5202a002b4b4fe$var$SR_REMOVAL_DELAY = 90;
function $6f5202a002b4b4fe$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $6f5202a002b4b4fe$var$create("span", $6f5202a002b4b4fe$export$bb78d7c200da8960);
    var interval = $6f5202a002b4b4fe$export$46ad21b25b6dccf0($6f5202a002b4b4fe$var$SR_REMOVAL_DELAY, $6f5202a002b4b4fe$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $6f5202a002b4b4fe$var$setAttribute(track, $6f5202a002b4b4fe$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($6f5202a002b4b4fe$export$23663268a31b79e2, $6f5202a002b4b4fe$var$apply(disable, true));
            on($6f5202a002b4b4fe$export$16a1e4f3d0368265, $6f5202a002b4b4fe$var$apply(disable, false));
            on([
                $6f5202a002b4b4fe$export$fe5802204b967f0d,
                $6f5202a002b4b4fe$export$ff8164bff3202b9
            ], $6f5202a002b4b4fe$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $6f5202a002b4b4fe$var$setAttribute(track, $6f5202a002b4b4fe$var$ARIA_BUSY, active);
        if (active) {
            $6f5202a002b4b4fe$var$append(track, sr);
            interval.start();
        } else {
            $6f5202a002b4b4fe$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $6f5202a002b4b4fe$var$removeAttribute(track, [
            $6f5202a002b4b4fe$var$ARIA_LIVE,
            $6f5202a002b4b4fe$var$ARIA_ATOMIC,
            $6f5202a002b4b4fe$var$ARIA_BUSY
        ]);
        $6f5202a002b4b4fe$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $6f5202a002b4b4fe$var$setAttribute(track, $6f5202a002b4b4fe$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $6f5202a002b4b4fe$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $6f5202a002b4b4fe$var$Media,
    Direction: $6f5202a002b4b4fe$var$Direction,
    Elements: $6f5202a002b4b4fe$var$Elements,
    Slides: $6f5202a002b4b4fe$var$Slides,
    Layout: $6f5202a002b4b4fe$var$Layout,
    Clones: $6f5202a002b4b4fe$var$Clones,
    Move: $6f5202a002b4b4fe$var$Move,
    Controller: $6f5202a002b4b4fe$var$Controller,
    Arrows: $6f5202a002b4b4fe$var$Arrows,
    Autoplay: $6f5202a002b4b4fe$var$Autoplay,
    Cover: $6f5202a002b4b4fe$var$Cover,
    Scroll: $6f5202a002b4b4fe$var$Scroll,
    Drag: $6f5202a002b4b4fe$var$Drag,
    Keyboard: $6f5202a002b4b4fe$var$Keyboard,
    LazyLoad: $6f5202a002b4b4fe$var$LazyLoad,
    Pagination: $6f5202a002b4b4fe$var$Pagination,
    Sync: $6f5202a002b4b4fe$var$Sync,
    Wheel: $6f5202a002b4b4fe$var$Wheel,
    Live: $6f5202a002b4b4fe$var$Live
});
var $6f5202a002b4b4fe$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $6f5202a002b4b4fe$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $6f5202a002b4b4fe$export$ba41d43e4a419565,
    i18n: $6f5202a002b4b4fe$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $6f5202a002b4b4fe$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2).on([
            $6f5202a002b4b4fe$export$d300dc1a2634364b,
            $6f5202a002b4b4fe$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $6f5202a002b4b4fe$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $6f5202a002b4b4fe$var$noop
    };
}
function $6f5202a002b4b4fe$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $6f5202a002b4b4fe$var$apply($6f5202a002b4b4fe$var$style, list, "transition");
    var endCallback;
    function mount() {
        $6f5202a002b4b4fe$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($6f5202a002b4b4fe$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($6f5202a002b4b4fe$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $6f5202a002b4b4fe$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $6f5202a002b4b4fe$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $6f5202a002b4b4fe$export$7254cc27399e90bd($6f5202a002b4b4fe$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $6f5202a002b4b4fe$var$isString(target) ? $6f5202a002b4b4fe$var$query(document, target) : target;
        $6f5202a002b4b4fe$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $6f5202a002b4b4fe$var$merge({
            label: $6f5202a002b4b4fe$var$getAttribute(root, $6f5202a002b4b4fe$var$ARIA_LABEL) || "",
            labelledby: $6f5202a002b4b4fe$var$getAttribute(root, $6f5202a002b4b4fe$var$ARIA_LABELLEDBY) || ""
        }, $6f5202a002b4b4fe$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $6f5202a002b4b4fe$var$merge(options, JSON.parse($6f5202a002b4b4fe$var$getAttribute(root, $6f5202a002b4b4fe$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $6f5202a002b4b4fe$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($6f5202a002b4b4fe$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $6f5202a002b4b4fe$var$assert(state.is([
            $6f5202a002b4b4fe$var$CREATED,
            $6f5202a002b4b4fe$var$DESTROYED
        ]), "Already mounted!");
        state.set($6f5202a002b4b4fe$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($6f5202a002b4b4fe$export$742b62a5690c060) ? $6f5202a002b4b4fe$var$Fade : $6f5202a002b4b4fe$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $6f5202a002b4b4fe$var$assign({}, $6f5202a002b4b4fe$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $6f5202a002b4b4fe$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $6f5202a002b4b4fe$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($6f5202a002b4b4fe$export$d300dc1a2634364b);
        $6f5202a002b4b4fe$var$addClass(this.root, $6f5202a002b4b4fe$export$7761661e2d5b9388);
        state.set($6f5202a002b4b4fe$var$IDLE);
        this.emit($6f5202a002b4b4fe$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($6f5202a002b4b4fe$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($6f5202a002b4b4fe$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($6f5202a002b4b4fe$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($6f5202a002b4b4fe$var$CREATED)) $6f5202a002b4b4fe$export$f188226459c8a3ff(this).on($6f5202a002b4b4fe$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $6f5202a002b4b4fe$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($6f5202a002b4b4fe$export$88c4cf7419e470cd);
            event.destroy();
            completely && $6f5202a002b4b4fe$var$empty(this.splides);
            state.set($6f5202a002b4b4fe$var$DESTROYED);
        }
        return this;
    };
    $6f5202a002b4b4fe$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $6f5202a002b4b4fe$export$24494c7438c070bf = $6f5202a002b4b4fe$var$_Splide;
$6f5202a002b4b4fe$export$24494c7438c070bf.defaults = {};
$6f5202a002b4b4fe$export$24494c7438c070bf.STATES = $6f5202a002b4b4fe$var$STATES;
var $6f5202a002b4b4fe$var$CLASS_RENDERED = "is-rendered";
var $6f5202a002b4b4fe$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $6f5202a002b4b4fe$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $6f5202a002b4b4fe$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $6f5202a002b4b4fe$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $6f5202a002b4b4fe$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $6f5202a002b4b4fe$var$merge($6f5202a002b4b4fe$export$f484e977a69c6ba6, defaults || {});
        $6f5202a002b4b4fe$var$merge($6f5202a002b4b4fe$var$merge(this.options, $6f5202a002b4b4fe$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $6f5202a002b4b4fe$var$assign({}, $6f5202a002b4b4fe$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $6f5202a002b4b4fe$var$uniqueId("splide");
        this.Style = new $6f5202a002b4b4fe$var$Style(this.id, this.options);
        this.Direction = $6f5202a002b4b4fe$var$Direction(null, null, this.options);
        $6f5202a002b4b4fe$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $6f5202a002b4b4fe$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $6f5202a002b4b4fe$var$queryAll(root, "." + $6f5202a002b4b4fe$export$2c1ba4a4f1aa4947);
        on($6f5202a002b4b4fe$export$d300dc1a2634364b, function() {
            $6f5202a002b4b4fe$var$remove($6f5202a002b4b4fe$var$child(root, "style"));
        });
        $6f5202a002b4b4fe$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $6f5202a002b4b4fe$var$push(this.slides, this.contents.map(function(content, index) {
            content = $6f5202a002b4b4fe$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $6f5202a002b4b4fe$export$72d36ecf3758cb4b : "");
            $6f5202a002b4b4fe$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $6f5202a002b4b4fe$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $6f5202a002b4b4fe$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $6f5202a002b4b4fe$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $6f5202a002b4b4fe$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $6f5202a002b4b4fe$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $6f5202a002b4b4fe$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $6f5202a002b4b4fe$var$unit(padding[prop] || ($6f5202a002b4b4fe$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $6f5202a002b4b4fe$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $6f5202a002b4b4fe$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $6f5202a002b4b4fe$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $6f5202a002b4b4fe$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $6f5202a002b4b4fe$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($6f5202a002b4b4fe$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $6f5202a002b4b4fe$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $6f5202a002b4b4fe$var$merge($6f5202a002b4b4fe$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $6f5202a002b4b4fe$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $6f5202a002b4b4fe$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $6f5202a002b4b4fe$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $6f5202a002b4b4fe$export$93b21159ad85c843,
            $6f5202a002b4b4fe$export$93b21159ad85c843 + "--" + options.type,
            $6f5202a002b4b4fe$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $6f5202a002b4b4fe$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $6f5202a002b4b4fe$export$93b21159ad85c843 + "--nav",
            $6f5202a002b4b4fe$export$72d36ecf3758cb4b,
            !this.config.hidden && $6f5202a002b4b4fe$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $6f5202a002b4b4fe$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $6f5202a002b4b4fe$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $6f5202a002b4b4fe$var$forOwn(styles, function(value, key) {
            style += " " + $6f5202a002b4b4fe$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$6f5202a002b4b4fe$var$push(slides, slides);
        $6f5202a002b4b4fe$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $6f5202a002b4b4fe$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $6f5202a002b4b4fe$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $6f5202a002b4b4fe$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $6f5202a002b4b4fe$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $6f5202a002b4b4fe$var$SIZE + " " + $6f5202a002b4b4fe$var$SIZE + '" width="' + $6f5202a002b4b4fe$var$SIZE + '" height="' + $6f5202a002b4b4fe$var$SIZE + '"><path d="' + (this.options.arrowPath || $6f5202a002b4b4fe$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


// packages/alpinejs/src/scheduler.js
var $286191e2308b7169$var$flushPending = false;
var $286191e2308b7169$var$flushing = false;
var $286191e2308b7169$var$queue = [];
var $286191e2308b7169$var$lastFlushedIndex = -1;
function $286191e2308b7169$var$scheduler(callback) {
    $286191e2308b7169$var$queueJob(callback);
}
function $286191e2308b7169$var$queueJob(job) {
    if (!$286191e2308b7169$var$queue.includes(job)) $286191e2308b7169$var$queue.push(job);
    $286191e2308b7169$var$queueFlush();
}
function $286191e2308b7169$var$dequeueJob(job) {
    let index = $286191e2308b7169$var$queue.indexOf(job);
    if (index !== -1 && index > $286191e2308b7169$var$lastFlushedIndex) $286191e2308b7169$var$queue.splice(index, 1);
}
function $286191e2308b7169$var$queueFlush() {
    if (!$286191e2308b7169$var$flushing && !$286191e2308b7169$var$flushPending) {
        $286191e2308b7169$var$flushPending = true;
        queueMicrotask($286191e2308b7169$var$flushJobs);
    }
}
function $286191e2308b7169$var$flushJobs() {
    $286191e2308b7169$var$flushPending = false;
    $286191e2308b7169$var$flushing = true;
    for(let i = 0; i < $286191e2308b7169$var$queue.length; i++){
        $286191e2308b7169$var$queue[i]();
        $286191e2308b7169$var$lastFlushedIndex = i;
    }
    $286191e2308b7169$var$queue.length = 0;
    $286191e2308b7169$var$lastFlushedIndex = -1;
    $286191e2308b7169$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $286191e2308b7169$var$reactive;
var $286191e2308b7169$var$effect;
var $286191e2308b7169$var$release;
var $286191e2308b7169$var$raw;
var $286191e2308b7169$var$shouldSchedule = true;
function $286191e2308b7169$var$disableEffectScheduling(callback) {
    $286191e2308b7169$var$shouldSchedule = false;
    callback();
    $286191e2308b7169$var$shouldSchedule = true;
}
function $286191e2308b7169$var$setReactivityEngine(engine) {
    $286191e2308b7169$var$reactive = engine.reactive;
    $286191e2308b7169$var$release = engine.release;
    $286191e2308b7169$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($286191e2308b7169$var$shouldSchedule) $286191e2308b7169$var$scheduler(task);
                else task();
            }
        });
    $286191e2308b7169$var$raw = engine.raw;
}
function $286191e2308b7169$var$overrideEffect(override) {
    $286191e2308b7169$var$effect = override;
}
function $286191e2308b7169$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $286191e2308b7169$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $286191e2308b7169$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
// packages/alpinejs/src/utils/dispatch.js
function $286191e2308b7169$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $286191e2308b7169$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$286191e2308b7169$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $286191e2308b7169$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $286191e2308b7169$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $286191e2308b7169$var$started = false;
function $286191e2308b7169$var$start() {
    if ($286191e2308b7169$var$started) $286191e2308b7169$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $286191e2308b7169$var$started = true;
    if (!document.body) $286191e2308b7169$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $286191e2308b7169$var$dispatch(document, "alpine:init");
    $286191e2308b7169$var$dispatch(document, "alpine:initializing");
    $286191e2308b7169$var$startObservingMutations();
    $286191e2308b7169$var$onElAdded((el)=>$286191e2308b7169$var$initTree(el, $286191e2308b7169$var$walk));
    $286191e2308b7169$var$onElRemoved((el)=>$286191e2308b7169$var$destroyTree(el));
    $286191e2308b7169$var$onAttributesAdded((el, attrs)=>{
        $286191e2308b7169$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$286191e2308b7169$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($286191e2308b7169$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $286191e2308b7169$var$initTree(el);
    });
    $286191e2308b7169$var$dispatch(document, "alpine:initialized");
}
var $286191e2308b7169$var$rootSelectorCallbacks = [];
var $286191e2308b7169$var$initSelectorCallbacks = [];
function $286191e2308b7169$var$rootSelectors() {
    return $286191e2308b7169$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $286191e2308b7169$var$allSelectors() {
    return $286191e2308b7169$var$rootSelectorCallbacks.concat($286191e2308b7169$var$initSelectorCallbacks).map((fn)=>fn());
}
function $286191e2308b7169$var$addRootSelector(selectorCallback) {
    $286191e2308b7169$var$rootSelectorCallbacks.push(selectorCallback);
}
function $286191e2308b7169$var$addInitSelector(selectorCallback) {
    $286191e2308b7169$var$initSelectorCallbacks.push(selectorCallback);
}
function $286191e2308b7169$var$closestRoot(el, includeInitSelectors = false) {
    return $286191e2308b7169$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $286191e2308b7169$var$allSelectors() : $286191e2308b7169$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $286191e2308b7169$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $286191e2308b7169$var$findClosest(el.parentElement, callback);
}
function $286191e2308b7169$var$isRoot(el) {
    return $286191e2308b7169$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $286191e2308b7169$var$initInterceptors = [];
function $286191e2308b7169$var$interceptInit(callback) {
    $286191e2308b7169$var$initInterceptors.push(callback);
}
function $286191e2308b7169$var$initTree(el, walker = $286191e2308b7169$var$walk, intercept = ()=>{}) {
    $286191e2308b7169$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $286191e2308b7169$var$initInterceptors.forEach((i)=>i(el2, skip));
            $286191e2308b7169$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $286191e2308b7169$var$destroyTree(root) {
    $286191e2308b7169$var$walk(root, (el)=>{
        $286191e2308b7169$var$cleanupAttributes(el);
        $286191e2308b7169$var$cleanupElement(el);
    });
}
// packages/alpinejs/src/mutation.js
var $286191e2308b7169$var$onAttributeAddeds = [];
var $286191e2308b7169$var$onElRemoveds = [];
var $286191e2308b7169$var$onElAddeds = [];
function $286191e2308b7169$var$onElAdded(callback) {
    $286191e2308b7169$var$onElAddeds.push(callback);
}
function $286191e2308b7169$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $286191e2308b7169$var$onElRemoveds.push(callback);
    }
}
function $286191e2308b7169$var$onAttributesAdded(callback) {
    $286191e2308b7169$var$onAttributeAddeds.push(callback);
}
function $286191e2308b7169$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $286191e2308b7169$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $286191e2308b7169$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $286191e2308b7169$var$observer = new MutationObserver($286191e2308b7169$var$onMutate);
var $286191e2308b7169$var$currentlyObserving = false;
function $286191e2308b7169$var$startObservingMutations() {
    $286191e2308b7169$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $286191e2308b7169$var$currentlyObserving = true;
}
function $286191e2308b7169$var$stopObservingMutations() {
    $286191e2308b7169$var$flushObserver();
    $286191e2308b7169$var$observer.disconnect();
    $286191e2308b7169$var$currentlyObserving = false;
}
var $286191e2308b7169$var$recordQueue = [];
var $286191e2308b7169$var$willProcessRecordQueue = false;
function $286191e2308b7169$var$flushObserver() {
    $286191e2308b7169$var$recordQueue = $286191e2308b7169$var$recordQueue.concat($286191e2308b7169$var$observer.takeRecords());
    if ($286191e2308b7169$var$recordQueue.length && !$286191e2308b7169$var$willProcessRecordQueue) {
        $286191e2308b7169$var$willProcessRecordQueue = true;
        queueMicrotask(()=>{
            $286191e2308b7169$var$processRecordQueue();
            $286191e2308b7169$var$willProcessRecordQueue = false;
        });
    }
}
function $286191e2308b7169$var$processRecordQueue() {
    $286191e2308b7169$var$onMutate($286191e2308b7169$var$recordQueue);
    $286191e2308b7169$var$recordQueue.length = 0;
}
function $286191e2308b7169$var$mutateDom(callback) {
    if (!$286191e2308b7169$var$currentlyObserving) return callback();
    $286191e2308b7169$var$stopObservingMutations();
    let result = callback();
    $286191e2308b7169$var$startObservingMutations();
    return result;
}
var $286191e2308b7169$var$isCollecting = false;
var $286191e2308b7169$var$deferredMutations = [];
function $286191e2308b7169$var$deferMutations() {
    $286191e2308b7169$var$isCollecting = true;
}
function $286191e2308b7169$var$flushAndStopDeferringMutations() {
    $286191e2308b7169$var$isCollecting = false;
    $286191e2308b7169$var$onMutate($286191e2308b7169$var$deferredMutations);
    $286191e2308b7169$var$deferredMutations = [];
}
function $286191e2308b7169$var$onMutate(mutations) {
    if ($286191e2308b7169$var$isCollecting) {
        $286191e2308b7169$var$deferredMutations = $286191e2308b7169$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = [];
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.push(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.push(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $286191e2308b7169$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $286191e2308b7169$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.includes(node)) continue;
        $286191e2308b7169$var$onElRemoveds.forEach((i)=>i(node));
        $286191e2308b7169$var$destroyTree(node);
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.includes(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $286191e2308b7169$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $286191e2308b7169$var$scope(node) {
    return $286191e2308b7169$var$mergeProxies($286191e2308b7169$var$closestDataStack(node));
}
function $286191e2308b7169$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$286191e2308b7169$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $286191e2308b7169$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $286191e2308b7169$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $286191e2308b7169$var$closestDataStack(node.parentNode);
}
function $286191e2308b7169$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $286191e2308b7169$var$mergeProxyTrap);
}
var $286191e2308b7169$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $286191e2308b7169$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if ((descriptor === null || descriptor === void 0 ? void 0 : descriptor.set) && (descriptor === null || descriptor === void 0 ? void 0 : descriptor.get)) return Reflect.set(target, name, value, thisProxy);
        return Reflect.set(target, name, value);
    }
};
function $286191e2308b7169$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $286191e2308b7169$var$initInterceptors2(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $286191e2308b7169$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$286191e2308b7169$var$get(data2, path), (value)=>$286191e2308b7169$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $286191e2308b7169$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $286191e2308b7169$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $286191e2308b7169$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $286191e2308b7169$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $286191e2308b7169$var$magics = {};
function $286191e2308b7169$var$magic(name, callback) {
    $286191e2308b7169$var$magics[name] = callback;
}
function $286191e2308b7169$var$injectMagics(obj, el) {
    Object.entries($286191e2308b7169$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $286191e2308b7169$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $286191e2308b7169$var$interceptor,
                    ...utilities
                };
                $286191e2308b7169$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $286191e2308b7169$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $286191e2308b7169$var$handleError(e, el, expression);
    }
}
function $286191e2308b7169$var$handleError(error2, el, expression) {
    Object.assign(error2, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $286191e2308b7169$var$shouldAutoEvaluateFunctions = true;
function $286191e2308b7169$var$dontAutoEvaluateFunctions(callback) {
    let cache = $286191e2308b7169$var$shouldAutoEvaluateFunctions;
    $286191e2308b7169$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $286191e2308b7169$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $286191e2308b7169$var$evaluate(el, expression, extras = {}) {
    let result;
    $286191e2308b7169$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $286191e2308b7169$var$evaluateLater(...args) {
    return $286191e2308b7169$var$theEvaluatorFunction(...args);
}
var $286191e2308b7169$var$theEvaluatorFunction = $286191e2308b7169$var$normalEvaluator;
function $286191e2308b7169$var$setEvaluator(newEvaluator) {
    $286191e2308b7169$var$theEvaluatorFunction = newEvaluator;
}
function $286191e2308b7169$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $286191e2308b7169$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$286191e2308b7169$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $286191e2308b7169$var$generateEvaluatorFromFunction(dataStack, expression) : $286191e2308b7169$var$generateEvaluatorFromString(dataStack, expression, el);
    return $286191e2308b7169$var$tryCatch.bind(null, el, expression, evaluator);
}
function $286191e2308b7169$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($286191e2308b7169$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $286191e2308b7169$var$runIfTypeOfFunction(receiver, result);
    };
}
var $286191e2308b7169$var$evaluatorMemo = {};
function $286191e2308b7169$var$generateFunctionFromString(expression, el) {
    if ($286191e2308b7169$var$evaluatorMemo[expression]) return $286191e2308b7169$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $286191e2308b7169$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $286191e2308b7169$var$evaluatorMemo[expression] = func;
    return func;
}
function $286191e2308b7169$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $286191e2308b7169$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $286191e2308b7169$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$286191e2308b7169$var$handleError(error2, el, expression));
            if (func.finished) {
                $286191e2308b7169$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $286191e2308b7169$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$286191e2308b7169$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $286191e2308b7169$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($286191e2308b7169$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$286191e2308b7169$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$286191e2308b7169$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $286191e2308b7169$var$prefixAsString = "x-";
function $286191e2308b7169$var$prefix(subject = "") {
    return $286191e2308b7169$var$prefixAsString + subject;
}
function $286191e2308b7169$var$setPrefix(newPrefix) {
    $286191e2308b7169$var$prefixAsString = newPrefix;
}
var $286191e2308b7169$var$directiveHandlers = {};
function $286191e2308b7169$var$directive(name, callback) {
    $286191e2308b7169$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$286191e2308b7169$var$directiveHandlers[directive2]) {
                console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
                return;
            }
            const pos = $286191e2308b7169$var$directiveOrder.indexOf(directive2);
            $286191e2308b7169$var$directiveOrder.splice(pos >= 0 ? pos : $286191e2308b7169$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $286191e2308b7169$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $286191e2308b7169$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($286191e2308b7169$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($286191e2308b7169$var$outNonAlpineAttributes).map($286191e2308b7169$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($286191e2308b7169$var$byPriority);
    return directives2.map((directive2)=>{
        return $286191e2308b7169$var$getDirectiveHandler(el, directive2);
    });
}
function $286191e2308b7169$var$attributesOnly(attributes) {
    return Array.from(attributes).map($286191e2308b7169$var$toTransformedAttributes()).filter((attr)=>!$286191e2308b7169$var$outNonAlpineAttributes(attr));
}
var $286191e2308b7169$var$isDeferringHandlers = false;
var $286191e2308b7169$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $286191e2308b7169$var$currentHandlerStackKey = Symbol();
function $286191e2308b7169$var$deferHandlingDirectives(callback) {
    $286191e2308b7169$var$isDeferringHandlers = true;
    let key = Symbol();
    $286191e2308b7169$var$currentHandlerStackKey = key;
    $286191e2308b7169$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($286191e2308b7169$var$directiveHandlerStacks.get(key).length)$286191e2308b7169$var$directiveHandlerStacks.get(key).shift()();
        $286191e2308b7169$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $286191e2308b7169$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $286191e2308b7169$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $286191e2308b7169$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $286191e2308b7169$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $286191e2308b7169$var$evaluateLater.bind($286191e2308b7169$var$evaluateLater, el),
        evaluate: $286191e2308b7169$var$evaluate.bind($286191e2308b7169$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $286191e2308b7169$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $286191e2308b7169$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $286191e2308b7169$var$getElementBoundUtilities(el);
    $286191e2308b7169$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $286191e2308b7169$var$isDeferringHandlers ? $286191e2308b7169$var$directiveHandlerStacks.get($286191e2308b7169$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $286191e2308b7169$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $286191e2308b7169$var$into = (i)=>i;
function $286191e2308b7169$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $286191e2308b7169$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $286191e2308b7169$var$attributeTransformers = [];
function $286191e2308b7169$var$mapAttributes(callback) {
    $286191e2308b7169$var$attributeTransformers.push(callback);
}
function $286191e2308b7169$var$outNonAlpineAttributes({ name: name }) {
    return $286191e2308b7169$var$alpineAttributeRegex().test(name);
}
var $286191e2308b7169$var$alpineAttributeRegex = ()=>new RegExp(`^${$286191e2308b7169$var$prefixAsString}([^:^.]+)\\b`);
function $286191e2308b7169$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($286191e2308b7169$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $286191e2308b7169$var$DEFAULT = "DEFAULT";
var $286191e2308b7169$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $286191e2308b7169$var$DEFAULT,
    "teleport"
];
function $286191e2308b7169$var$byPriority(a, b) {
    let typeA = $286191e2308b7169$var$directiveOrder.indexOf(a.type) === -1 ? $286191e2308b7169$var$DEFAULT : a.type;
    let typeB = $286191e2308b7169$var$directiveOrder.indexOf(b.type) === -1 ? $286191e2308b7169$var$DEFAULT : b.type;
    return $286191e2308b7169$var$directiveOrder.indexOf(typeA) - $286191e2308b7169$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/nextTick.js
var $286191e2308b7169$var$tickStack = [];
var $286191e2308b7169$var$isHolding = false;
function $286191e2308b7169$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $286191e2308b7169$var$isHolding || setTimeout(()=>{
            $286191e2308b7169$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $286191e2308b7169$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $286191e2308b7169$var$releaseNextTicks() {
    $286191e2308b7169$var$isHolding = false;
    while($286191e2308b7169$var$tickStack.length)$286191e2308b7169$var$tickStack.shift()();
}
function $286191e2308b7169$var$holdNextTicks() {
    $286191e2308b7169$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $286191e2308b7169$var$setClasses(el, value) {
    if (Array.isArray(value)) return $286191e2308b7169$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $286191e2308b7169$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $286191e2308b7169$var$setClasses(el, value());
    return $286191e2308b7169$var$setClassesFromString(el, value);
}
function $286191e2308b7169$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $286191e2308b7169$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $286191e2308b7169$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $286191e2308b7169$var$setStylesFromObject(el, value);
    return $286191e2308b7169$var$setStylesFromString(el, value);
}
function $286191e2308b7169$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $286191e2308b7169$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $286191e2308b7169$var$setStyles(el, previousStyles);
    };
}
function $286191e2308b7169$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $286191e2308b7169$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $286191e2308b7169$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$286191e2308b7169$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $286191e2308b7169$var$registerTransitionsFromHelper(el, modifiers, value);
    else $286191e2308b7169$var$registerTransitionsFromClassString(el, expression, value);
});
function $286191e2308b7169$var$registerTransitionsFromClassString(el, classString, stage) {
    $286191e2308b7169$var$registerTransitionObject(el, $286191e2308b7169$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $286191e2308b7169$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $286191e2308b7169$var$registerTransitionObject(el, $286191e2308b7169$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $286191e2308b7169$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $286191e2308b7169$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $286191e2308b7169$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $286191e2308b7169$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $286191e2308b7169$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $286191e2308b7169$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $286191e2308b7169$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $286191e2308b7169$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $286191e2308b7169$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $286191e2308b7169$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $286191e2308b7169$var$closestHide(parent);
}
function $286191e2308b7169$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $286191e2308b7169$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $286191e2308b7169$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $286191e2308b7169$var$once(()=>{
        $286191e2308b7169$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $286191e2308b7169$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $286191e2308b7169$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $286191e2308b7169$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $286191e2308b7169$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $286191e2308b7169$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $286191e2308b7169$var$mutateDom(()=>{
                stages.end();
            });
            $286191e2308b7169$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $286191e2308b7169$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $286191e2308b7169$var$isCloning = false;
function $286191e2308b7169$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$286191e2308b7169$var$isCloning ? fallback(...args) : callback(...args);
}
function $286191e2308b7169$var$onlyDuringClone(callback) {
    return (...args)=>$286191e2308b7169$var$isCloning && callback(...args);
}
var $286191e2308b7169$var$interceptors = [];
function $286191e2308b7169$var$interceptClone(callback) {
    $286191e2308b7169$var$interceptors.push(callback);
}
function $286191e2308b7169$var$cloneNode(from, to) {
    $286191e2308b7169$var$interceptors.forEach((i)=>i(from, to));
    $286191e2308b7169$var$isCloning = true;
    $286191e2308b7169$var$dontRegisterReactiveSideEffects(()=>{
        $286191e2308b7169$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $286191e2308b7169$var$isCloning = false;
}
var $286191e2308b7169$var$isCloningLegacy = false;
function $286191e2308b7169$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $286191e2308b7169$var$isCloning = true;
    $286191e2308b7169$var$isCloningLegacy = true;
    $286191e2308b7169$var$dontRegisterReactiveSideEffects(()=>{
        $286191e2308b7169$var$cloneTree(newEl);
    });
    $286191e2308b7169$var$isCloning = false;
    $286191e2308b7169$var$isCloningLegacy = false;
}
function $286191e2308b7169$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $286191e2308b7169$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $286191e2308b7169$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $286191e2308b7169$var$initTree(el, shallowWalker);
}
function $286191e2308b7169$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $286191e2308b7169$var$effect;
    $286191e2308b7169$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $286191e2308b7169$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $286191e2308b7169$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $286191e2308b7169$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $286191e2308b7169$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $286191e2308b7169$var$camelCase(name) : name;
    switch(name){
        case "value":
            $286191e2308b7169$var$bindInputValue(el, value);
            break;
        case "style":
            $286191e2308b7169$var$bindStyles(el, value);
            break;
        case "class":
            $286191e2308b7169$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $286191e2308b7169$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $286191e2308b7169$var$bindAttribute(el, name, value);
            break;
    }
}
function $286191e2308b7169$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $286191e2308b7169$var$safeParseBoolean(el.value) === value;
            else el.checked = $286191e2308b7169$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$286191e2308b7169$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $286191e2308b7169$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $286191e2308b7169$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $286191e2308b7169$var$setClasses(el, value);
}
function $286191e2308b7169$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $286191e2308b7169$var$setStyles(el, value);
}
function $286191e2308b7169$var$bindAttributeAndProperty(el, name, value) {
    $286191e2308b7169$var$bindAttribute(el, name, value);
    $286191e2308b7169$var$setPropertyIfChanged(el, name, value);
}
function $286191e2308b7169$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $286191e2308b7169$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($286191e2308b7169$var$isBooleanAttr(name)) value = name;
        $286191e2308b7169$var$setIfChanged(el, name, value);
    }
}
function $286191e2308b7169$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $286191e2308b7169$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $286191e2308b7169$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $286191e2308b7169$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $286191e2308b7169$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $286191e2308b7169$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $286191e2308b7169$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $286191e2308b7169$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $286191e2308b7169$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $286191e2308b7169$var$getAttributeBinding(el, name, fallback);
}
function $286191e2308b7169$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $286191e2308b7169$var$dontAutoEvaluateFunctions(()=>{
            return $286191e2308b7169$var$evaluate(el, binding.expression);
        });
    }
    return $286191e2308b7169$var$getAttributeBinding(el, name, fallback);
}
function $286191e2308b7169$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($286191e2308b7169$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $286191e2308b7169$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $286191e2308b7169$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $286191e2308b7169$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let reference = $286191e2308b7169$var$effect(()=>{
        const outer = outerGet();
        const inner = innerGet();
        if (firstRun) {
            innerSet($286191e2308b7169$var$cloneIfObject(outer));
            firstRun = false;
            outerHash = JSON.stringify(outer);
        } else {
            const outerHashLatest = JSON.stringify(outer);
            if (outerHashLatest !== outerHash) {
                innerSet($286191e2308b7169$var$cloneIfObject(outer));
                outerHash = outerHashLatest;
            } else {
                outerSet($286191e2308b7169$var$cloneIfObject(inner));
                outerHash = JSON.stringify(inner);
            }
        }
        JSON.stringify(innerGet());
        JSON.stringify(outerGet());
    });
    return ()=>{
        $286191e2308b7169$var$release(reference);
    };
}
function $286191e2308b7169$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $286191e2308b7169$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($286191e2308b7169$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $286191e2308b7169$var$stores = {};
var $286191e2308b7169$var$isReactive = false;
function $286191e2308b7169$var$store(name, value) {
    if (!$286191e2308b7169$var$isReactive) {
        $286191e2308b7169$var$stores = $286191e2308b7169$var$reactive($286191e2308b7169$var$stores);
        $286191e2308b7169$var$isReactive = true;
    }
    if (value === void 0) return $286191e2308b7169$var$stores[name];
    $286191e2308b7169$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $286191e2308b7169$var$stores[name].init();
    $286191e2308b7169$var$initInterceptors2($286191e2308b7169$var$stores[name]);
}
function $286191e2308b7169$var$getStores() {
    return $286191e2308b7169$var$stores;
}
// packages/alpinejs/src/binds.js
var $286191e2308b7169$var$binds = {};
function $286191e2308b7169$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $286191e2308b7169$var$applyBindingsObject(name, getBindings());
    else $286191e2308b7169$var$binds[name] = getBindings;
    return ()=>{};
}
function $286191e2308b7169$var$injectBindingProviders(obj) {
    Object.entries($286191e2308b7169$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $286191e2308b7169$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $286191e2308b7169$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $286191e2308b7169$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $286191e2308b7169$var$datas = {};
function $286191e2308b7169$var$data(name, callback) {
    $286191e2308b7169$var$datas[name] = callback;
}
function $286191e2308b7169$var$injectDataProviders(obj, context) {
    Object.entries($286191e2308b7169$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $286191e2308b7169$var$Alpine = {
    get reactive () {
        return $286191e2308b7169$var$reactive;
    },
    get release () {
        return $286191e2308b7169$var$release;
    },
    get effect () {
        return $286191e2308b7169$var$effect;
    },
    get raw () {
        return $286191e2308b7169$var$raw;
    },
    version: "3.13.3",
    flushAndStopDeferringMutations: $286191e2308b7169$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $286191e2308b7169$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $286191e2308b7169$var$disableEffectScheduling,
    startObservingMutations: $286191e2308b7169$var$startObservingMutations,
    stopObservingMutations: $286191e2308b7169$var$stopObservingMutations,
    setReactivityEngine: $286191e2308b7169$var$setReactivityEngine,
    onAttributeRemoved: $286191e2308b7169$var$onAttributeRemoved,
    onAttributesAdded: $286191e2308b7169$var$onAttributesAdded,
    closestDataStack: $286191e2308b7169$var$closestDataStack,
    skipDuringClone: $286191e2308b7169$var$skipDuringClone,
    onlyDuringClone: $286191e2308b7169$var$onlyDuringClone,
    addRootSelector: $286191e2308b7169$var$addRootSelector,
    addInitSelector: $286191e2308b7169$var$addInitSelector,
    interceptClone: $286191e2308b7169$var$interceptClone,
    addScopeToNode: $286191e2308b7169$var$addScopeToNode,
    deferMutations: $286191e2308b7169$var$deferMutations,
    mapAttributes: $286191e2308b7169$var$mapAttributes,
    evaluateLater: $286191e2308b7169$var$evaluateLater,
    interceptInit: $286191e2308b7169$var$interceptInit,
    setEvaluator: $286191e2308b7169$var$setEvaluator,
    mergeProxies: $286191e2308b7169$var$mergeProxies,
    extractProp: $286191e2308b7169$var$extractProp,
    findClosest: $286191e2308b7169$var$findClosest,
    onElRemoved: $286191e2308b7169$var$onElRemoved,
    closestRoot: $286191e2308b7169$var$closestRoot,
    destroyTree: $286191e2308b7169$var$destroyTree,
    interceptor: $286191e2308b7169$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $286191e2308b7169$var$transition,
    setStyles: // INTERNAL
    $286191e2308b7169$var$setStyles,
    mutateDom: // INTERNAL
    $286191e2308b7169$var$mutateDom,
    directive: $286191e2308b7169$var$directive,
    entangle: $286191e2308b7169$var$entangle,
    throttle: $286191e2308b7169$var$throttle,
    debounce: $286191e2308b7169$var$debounce,
    evaluate: $286191e2308b7169$var$evaluate,
    initTree: $286191e2308b7169$var$initTree,
    nextTick: $286191e2308b7169$var$nextTick,
    prefixed: $286191e2308b7169$var$prefix,
    prefix: $286191e2308b7169$var$setPrefix,
    plugin: $286191e2308b7169$var$plugin,
    magic: $286191e2308b7169$var$magic,
    store: $286191e2308b7169$var$store,
    start: $286191e2308b7169$var$start,
    clone: $286191e2308b7169$var$clone,
    cloneNode: // INTERNAL
    $286191e2308b7169$var$cloneNode,
    // INTERNAL
    bound: $286191e2308b7169$var$getBinding,
    $data: $286191e2308b7169$var$scope,
    walk: $286191e2308b7169$var$walk,
    data: $286191e2308b7169$var$data,
    bind: $286191e2308b7169$var$bind2
};
var $286191e2308b7169$var$alpine_default = $286191e2308b7169$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $286191e2308b7169$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $286191e2308b7169$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $286191e2308b7169$var$isBooleanAttr2 = /* @__PURE__ */ $286191e2308b7169$var$makeMap($286191e2308b7169$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $286191e2308b7169$var$EMPTY_OBJ = Object.freeze({});
var $286191e2308b7169$var$EMPTY_ARR = Object.freeze([]);
var $286191e2308b7169$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $286191e2308b7169$var$hasOwn = (val, key)=>$286191e2308b7169$var$hasOwnProperty.call(val, key);
var $286191e2308b7169$var$isArray = Array.isArray;
var $286191e2308b7169$var$isMap = (val)=>$286191e2308b7169$var$toTypeString(val) === "[object Map]";
var $286191e2308b7169$var$isString = (val)=>typeof val === "string";
var $286191e2308b7169$var$isSymbol = (val)=>typeof val === "symbol";
var $286191e2308b7169$var$isObject = (val)=>val !== null && typeof val === "object";
var $286191e2308b7169$var$objectToString = Object.prototype.toString;
var $286191e2308b7169$var$toTypeString = (value)=>$286191e2308b7169$var$objectToString.call(value);
var $286191e2308b7169$var$toRawType = (value)=>{
    return $286191e2308b7169$var$toTypeString(value).slice(8, -1);
};
var $286191e2308b7169$var$isIntegerKey = (key)=>$286191e2308b7169$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $286191e2308b7169$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $286191e2308b7169$var$camelizeRE = /-(\w)/g;
var $286191e2308b7169$var$camelize = $286191e2308b7169$var$cacheStringFunction((str)=>{
    return str.replace($286191e2308b7169$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $286191e2308b7169$var$hyphenateRE = /\B([A-Z])/g;
var $286191e2308b7169$var$hyphenate = $286191e2308b7169$var$cacheStringFunction((str)=>str.replace($286191e2308b7169$var$hyphenateRE, "-$1").toLowerCase());
var $286191e2308b7169$var$capitalize = $286191e2308b7169$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $286191e2308b7169$var$toHandlerKey = $286191e2308b7169$var$cacheStringFunction((str)=>str ? `on${$286191e2308b7169$var$capitalize(str)}` : ``);
var $286191e2308b7169$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $286191e2308b7169$var$targetMap = /* @__PURE__ */ new WeakMap();
var $286191e2308b7169$var$effectStack = [];
var $286191e2308b7169$var$activeEffect;
var $286191e2308b7169$var$ITERATE_KEY = Symbol("iterate");
var $286191e2308b7169$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $286191e2308b7169$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $286191e2308b7169$var$effect2(fn, options = $286191e2308b7169$var$EMPTY_OBJ) {
    if ($286191e2308b7169$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $286191e2308b7169$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $286191e2308b7169$var$stop(effect3) {
    if (effect3.active) {
        $286191e2308b7169$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $286191e2308b7169$var$uid = 0;
function $286191e2308b7169$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$286191e2308b7169$var$effectStack.includes(effect3)) {
            $286191e2308b7169$var$cleanup(effect3);
            try {
                $286191e2308b7169$var$enableTracking();
                $286191e2308b7169$var$effectStack.push(effect3);
                $286191e2308b7169$var$activeEffect = effect3;
                return fn();
            } finally{
                $286191e2308b7169$var$effectStack.pop();
                $286191e2308b7169$var$resetTracking();
                $286191e2308b7169$var$activeEffect = $286191e2308b7169$var$effectStack[$286191e2308b7169$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $286191e2308b7169$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $286191e2308b7169$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $286191e2308b7169$var$shouldTrack = true;
var $286191e2308b7169$var$trackStack = [];
function $286191e2308b7169$var$pauseTracking() {
    $286191e2308b7169$var$trackStack.push($286191e2308b7169$var$shouldTrack);
    $286191e2308b7169$var$shouldTrack = false;
}
function $286191e2308b7169$var$enableTracking() {
    $286191e2308b7169$var$trackStack.push($286191e2308b7169$var$shouldTrack);
    $286191e2308b7169$var$shouldTrack = true;
}
function $286191e2308b7169$var$resetTracking() {
    const last = $286191e2308b7169$var$trackStack.pop();
    $286191e2308b7169$var$shouldTrack = last === void 0 ? true : last;
}
function $286191e2308b7169$var$track(target, type, key) {
    if (!$286191e2308b7169$var$shouldTrack || $286191e2308b7169$var$activeEffect === void 0) return;
    let depsMap = $286191e2308b7169$var$targetMap.get(target);
    if (!depsMap) $286191e2308b7169$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($286191e2308b7169$var$activeEffect)) {
        dep.add($286191e2308b7169$var$activeEffect);
        $286191e2308b7169$var$activeEffect.deps.push(dep);
        if ($286191e2308b7169$var$activeEffect.options.onTrack) $286191e2308b7169$var$activeEffect.options.onTrack({
            effect: $286191e2308b7169$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $286191e2308b7169$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $286191e2308b7169$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $286191e2308b7169$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $286191e2308b7169$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$286191e2308b7169$var$isArray(target)) {
                    add2(depsMap.get($286191e2308b7169$var$ITERATE_KEY));
                    if ($286191e2308b7169$var$isMap(target)) add2(depsMap.get($286191e2308b7169$var$MAP_KEY_ITERATE_KEY));
                } else if ($286191e2308b7169$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$286191e2308b7169$var$isArray(target)) {
                    add2(depsMap.get($286191e2308b7169$var$ITERATE_KEY));
                    if ($286191e2308b7169$var$isMap(target)) add2(depsMap.get($286191e2308b7169$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($286191e2308b7169$var$isMap(target)) add2(depsMap.get($286191e2308b7169$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $286191e2308b7169$var$isNonTrackableKeys = /* @__PURE__ */ $286191e2308b7169$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $286191e2308b7169$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($286191e2308b7169$var$isSymbol));
var $286191e2308b7169$var$get2 = /* @__PURE__ */ $286191e2308b7169$var$createGetter();
var $286191e2308b7169$var$readonlyGet = /* @__PURE__ */ $286191e2308b7169$var$createGetter(true);
var $286191e2308b7169$var$arrayInstrumentations = /* @__PURE__ */ $286191e2308b7169$var$createArrayInstrumentations();
function $286191e2308b7169$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $286191e2308b7169$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$286191e2308b7169$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($286191e2308b7169$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $286191e2308b7169$var$pauseTracking();
            const res = $286191e2308b7169$var$toRaw(this)[key].apply(this, args);
            $286191e2308b7169$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $286191e2308b7169$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $286191e2308b7169$var$shallowReadonlyMap : $286191e2308b7169$var$readonlyMap : shallow ? $286191e2308b7169$var$shallowReactiveMap : $286191e2308b7169$var$reactiveMap).get(target)) return target;
        const targetIsArray = $286191e2308b7169$var$isArray(target);
        if (!isReadonly && targetIsArray && $286191e2308b7169$var$hasOwn($286191e2308b7169$var$arrayInstrumentations, key)) return Reflect.get($286191e2308b7169$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($286191e2308b7169$var$isSymbol(key) ? $286191e2308b7169$var$builtInSymbols.has(key) : $286191e2308b7169$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $286191e2308b7169$var$track(target, "get", key);
        if (shallow) return res;
        if ($286191e2308b7169$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$286191e2308b7169$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($286191e2308b7169$var$isObject(res)) return isReadonly ? $286191e2308b7169$var$readonly(res) : $286191e2308b7169$var$reactive2(res);
        return res;
    };
}
var $286191e2308b7169$var$set2 = /* @__PURE__ */ $286191e2308b7169$var$createSetter();
function $286191e2308b7169$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $286191e2308b7169$var$toRaw(value);
            oldValue = $286191e2308b7169$var$toRaw(oldValue);
            if (!$286191e2308b7169$var$isArray(target) && $286191e2308b7169$var$isRef(oldValue) && !$286191e2308b7169$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $286191e2308b7169$var$isArray(target) && $286191e2308b7169$var$isIntegerKey(key) ? Number(key) < target.length : $286191e2308b7169$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $286191e2308b7169$var$toRaw(receiver)) {
            if (!hadKey) $286191e2308b7169$var$trigger(target, "add", key, value);
            else if ($286191e2308b7169$var$hasChanged(value, oldValue)) $286191e2308b7169$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $286191e2308b7169$var$deleteProperty(target, key) {
    const hadKey = $286191e2308b7169$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $286191e2308b7169$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $286191e2308b7169$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$286191e2308b7169$var$isSymbol(key) || !$286191e2308b7169$var$builtInSymbols.has(key)) $286191e2308b7169$var$track(target, "has", key);
    return result;
}
function $286191e2308b7169$var$ownKeys(target) {
    $286191e2308b7169$var$track(target, "iterate", $286191e2308b7169$var$isArray(target) ? "length" : $286191e2308b7169$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $286191e2308b7169$var$mutableHandlers = {
    get: $286191e2308b7169$var$get2,
    set: $286191e2308b7169$var$set2,
    deleteProperty: $286191e2308b7169$var$deleteProperty,
    has: $286191e2308b7169$var$has,
    ownKeys: $286191e2308b7169$var$ownKeys
};
var $286191e2308b7169$var$readonlyHandlers = {
    get: $286191e2308b7169$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $286191e2308b7169$var$toReactive = (value)=>$286191e2308b7169$var$isObject(value) ? $286191e2308b7169$var$reactive2(value) : value;
var $286191e2308b7169$var$toReadonly = (value)=>$286191e2308b7169$var$isObject(value) ? $286191e2308b7169$var$readonly(value) : value;
var $286191e2308b7169$var$toShallow = (value)=>value;
var $286191e2308b7169$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $286191e2308b7169$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $286191e2308b7169$var$toRaw(target);
    const rawKey = $286191e2308b7169$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $286191e2308b7169$var$track(rawTarget, "get", key);
    !isReadonly && $286191e2308b7169$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $286191e2308b7169$var$getProto(rawTarget);
    const wrap = isShallow ? $286191e2308b7169$var$toShallow : isReadonly ? $286191e2308b7169$var$toReadonly : $286191e2308b7169$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $286191e2308b7169$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $286191e2308b7169$var$toRaw(target);
    const rawKey = $286191e2308b7169$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $286191e2308b7169$var$track(rawTarget, "has", key);
    !isReadonly && $286191e2308b7169$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $286191e2308b7169$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $286191e2308b7169$var$track($286191e2308b7169$var$toRaw(target), "iterate", $286191e2308b7169$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $286191e2308b7169$var$add(value) {
    value = $286191e2308b7169$var$toRaw(value);
    const target = $286191e2308b7169$var$toRaw(this);
    const proto = $286191e2308b7169$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $286191e2308b7169$var$trigger(target, "add", value, value);
    }
    return this;
}
function $286191e2308b7169$var$set$1(key, value) {
    value = $286191e2308b7169$var$toRaw(value);
    const target = $286191e2308b7169$var$toRaw(this);
    const { has: has2, get: get3 } = $286191e2308b7169$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $286191e2308b7169$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $286191e2308b7169$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $286191e2308b7169$var$trigger(target, "add", key, value);
    else if ($286191e2308b7169$var$hasChanged(value, oldValue)) $286191e2308b7169$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $286191e2308b7169$var$deleteEntry(key) {
    const target = $286191e2308b7169$var$toRaw(this);
    const { has: has2, get: get3 } = $286191e2308b7169$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $286191e2308b7169$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $286191e2308b7169$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $286191e2308b7169$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $286191e2308b7169$var$clear() {
    const target = $286191e2308b7169$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $286191e2308b7169$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $286191e2308b7169$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $286191e2308b7169$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $286191e2308b7169$var$toRaw(target);
        const wrap = isShallow ? $286191e2308b7169$var$toShallow : isReadonly ? $286191e2308b7169$var$toReadonly : $286191e2308b7169$var$toReactive;
        !isReadonly && $286191e2308b7169$var$track(rawTarget, "iterate", $286191e2308b7169$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $286191e2308b7169$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $286191e2308b7169$var$toRaw(target);
        const targetIsMap = $286191e2308b7169$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $286191e2308b7169$var$toShallow : isReadonly ? $286191e2308b7169$var$toReadonly : $286191e2308b7169$var$toReactive;
        !isReadonly && $286191e2308b7169$var$track(rawTarget, "iterate", isKeyOnly ? $286191e2308b7169$var$MAP_KEY_ITERATE_KEY : $286191e2308b7169$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $286191e2308b7169$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$286191e2308b7169$var$capitalize(type)} operation ${key}failed: target is readonly.`, $286191e2308b7169$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $286191e2308b7169$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $286191e2308b7169$var$get$1(this, key);
        },
        get size () {
            return $286191e2308b7169$var$size(this);
        },
        has: $286191e2308b7169$var$has$1,
        add: $286191e2308b7169$var$add,
        set: $286191e2308b7169$var$set$1,
        delete: $286191e2308b7169$var$deleteEntry,
        clear: $286191e2308b7169$var$clear,
        forEach: $286191e2308b7169$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $286191e2308b7169$var$get$1(this, key, false, true);
        },
        get size () {
            return $286191e2308b7169$var$size(this);
        },
        has: $286191e2308b7169$var$has$1,
        add: $286191e2308b7169$var$add,
        set: $286191e2308b7169$var$set$1,
        delete: $286191e2308b7169$var$deleteEntry,
        clear: $286191e2308b7169$var$clear,
        forEach: $286191e2308b7169$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $286191e2308b7169$var$get$1(this, key, true);
        },
        get size () {
            return $286191e2308b7169$var$size(this, true);
        },
        has (key) {
            return $286191e2308b7169$var$has$1.call(this, key, true);
        },
        add: $286191e2308b7169$var$createReadonlyMethod("add"),
        set: $286191e2308b7169$var$createReadonlyMethod("set"),
        delete: $286191e2308b7169$var$createReadonlyMethod("delete"),
        clear: $286191e2308b7169$var$createReadonlyMethod("clear"),
        forEach: $286191e2308b7169$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $286191e2308b7169$var$get$1(this, key, true, true);
        },
        get size () {
            return $286191e2308b7169$var$size(this, true);
        },
        has (key) {
            return $286191e2308b7169$var$has$1.call(this, key, true);
        },
        add: $286191e2308b7169$var$createReadonlyMethod("add"),
        set: $286191e2308b7169$var$createReadonlyMethod("set"),
        delete: $286191e2308b7169$var$createReadonlyMethod("delete"),
        clear: $286191e2308b7169$var$createReadonlyMethod("clear"),
        forEach: $286191e2308b7169$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $286191e2308b7169$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $286191e2308b7169$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $286191e2308b7169$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $286191e2308b7169$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$286191e2308b7169$var$mutableInstrumentations, $286191e2308b7169$var$readonlyInstrumentations, $286191e2308b7169$var$shallowInstrumentations, $286191e2308b7169$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $286191e2308b7169$var$createInstrumentations();
function $286191e2308b7169$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $286191e2308b7169$var$shallowReadonlyInstrumentations : $286191e2308b7169$var$shallowInstrumentations : isReadonly ? $286191e2308b7169$var$readonlyInstrumentations : $286191e2308b7169$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($286191e2308b7169$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $286191e2308b7169$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $286191e2308b7169$var$createInstrumentationGetter(false, false)
};
var $286191e2308b7169$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $286191e2308b7169$var$createInstrumentationGetter(true, false)
};
function $286191e2308b7169$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $286191e2308b7169$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $286191e2308b7169$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $286191e2308b7169$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $286191e2308b7169$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $286191e2308b7169$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $286191e2308b7169$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $286191e2308b7169$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $286191e2308b7169$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $286191e2308b7169$var$targetTypeMap($286191e2308b7169$var$toRawType(value));
}
function $286191e2308b7169$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $286191e2308b7169$var$createReactiveObject(target, false, $286191e2308b7169$var$mutableHandlers, $286191e2308b7169$var$mutableCollectionHandlers, $286191e2308b7169$var$reactiveMap);
}
function $286191e2308b7169$var$readonly(target) {
    return $286191e2308b7169$var$createReactiveObject(target, true, $286191e2308b7169$var$readonlyHandlers, $286191e2308b7169$var$readonlyCollectionHandlers, $286191e2308b7169$var$readonlyMap);
}
function $286191e2308b7169$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$286191e2308b7169$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $286191e2308b7169$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $286191e2308b7169$var$toRaw(observed) {
    return observed && $286191e2308b7169$var$toRaw(observed["__v_raw"]) || observed;
}
function $286191e2308b7169$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$286191e2308b7169$var$magic("nextTick", ()=>$286191e2308b7169$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$286191e2308b7169$var$magic("dispatch", (el)=>$286191e2308b7169$var$dispatch.bind($286191e2308b7169$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$286191e2308b7169$var$magic("watch", (el, { evaluateLater: evaluateLater2, effect: effect3 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let firstTime = true;
        let oldValue;
        let effectReference = effect3(()=>evaluate2((value)=>{
                JSON.stringify(value);
                if (!firstTime) queueMicrotask(()=>{
                    callback(value, oldValue);
                    oldValue = value;
                });
                else oldValue = value;
                firstTime = false;
            }));
        el._x_effects.delete(effectReference);
    });
// packages/alpinejs/src/magics/$store.js
$286191e2308b7169$var$magic("store", $286191e2308b7169$var$getStores);
// packages/alpinejs/src/magics/$data.js
$286191e2308b7169$var$magic("data", (el)=>$286191e2308b7169$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$286191e2308b7169$var$magic("root", (el)=>$286191e2308b7169$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$286191e2308b7169$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $286191e2308b7169$var$mergeProxies($286191e2308b7169$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $286191e2308b7169$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $286191e2308b7169$var$globalIdMemo = {};
function $286191e2308b7169$var$findAndIncrementId(name) {
    if (!$286191e2308b7169$var$globalIdMemo[name]) $286191e2308b7169$var$globalIdMemo[name] = 0;
    return ++$286191e2308b7169$var$globalIdMemo[name];
}
function $286191e2308b7169$var$closestIdRoot(el, name) {
    return $286191e2308b7169$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $286191e2308b7169$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $286191e2308b7169$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$286191e2308b7169$var$magic("id", (el)=>(name, key = null)=>{
        let root = $286191e2308b7169$var$closestIdRoot(el, name);
        let id = root ? root._x_ids[name] : $286191e2308b7169$var$findAndIncrementId(name);
        return key ? `${name}-${id}-${key}` : `${name}-${id}`;
    });
// packages/alpinejs/src/magics/$el.js
$286191e2308b7169$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$286191e2308b7169$var$warnMissingPluginMagic("Focus", "focus", "focus");
$286191e2308b7169$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $286191e2308b7169$var$warnMissingPluginMagic(name, magicName, slug) {
    $286191e2308b7169$var$magic(magicName, (el)=>$286191e2308b7169$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$286191e2308b7169$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $286191e2308b7169$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$286191e2308b7169$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $286191e2308b7169$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $286191e2308b7169$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $286191e2308b7169$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $286191e2308b7169$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $286191e2308b7169$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $286191e2308b7169$var$getTarget(expression);
        $286191e2308b7169$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $286191e2308b7169$var$teleportContainerDuringClone = document.createElement("div");
function $286191e2308b7169$var$getTarget(expression) {
    let target = $286191e2308b7169$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $286191e2308b7169$var$teleportContainerDuringClone;
    })();
    if (!target) $286191e2308b7169$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $286191e2308b7169$var$handler = ()=>{};
$286191e2308b7169$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$286191e2308b7169$var$directive("ignore", $286191e2308b7169$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$286191e2308b7169$var$directive("effect", $286191e2308b7169$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($286191e2308b7169$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $286191e2308b7169$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $286191e2308b7169$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $286191e2308b7169$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $286191e2308b7169$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $286191e2308b7169$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $286191e2308b7169$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $286191e2308b7169$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($286191e2308b7169$var$isKeyEvent(event)) {
            if ($286191e2308b7169$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $286191e2308b7169$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $286191e2308b7169$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $286191e2308b7169$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $286191e2308b7169$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $286191e2308b7169$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $286191e2308b7169$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $286191e2308b7169$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $286191e2308b7169$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $286191e2308b7169$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($286191e2308b7169$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $286191e2308b7169$var$keyToModifiers(key) {
    if (!key) return [];
    key = $286191e2308b7169$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$286191e2308b7169$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $286191e2308b7169$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $286191e2308b7169$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $286191e2308b7169$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $286191e2308b7169$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($286191e2308b7169$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $286191e2308b7169$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $286191e2308b7169$var$isCloning ? ()=>{} : $286191e2308b7169$var$on(el, event, modifiers, (e)=>{
        setValue($286191e2308b7169$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue())) el.dispatchEvent(new Event(event, {}));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $286191e2308b7169$var$on(el.form, "reset", [], (e)=>{
            $286191e2308b7169$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $286191e2308b7169$var$mutateDom(()=>$286191e2308b7169$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $286191e2308b7169$var$getInputValue(el, modifiers, event, currentValue) {
    return $286191e2308b7169$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $286191e2308b7169$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $286191e2308b7169$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$286191e2308b7169$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $286191e2308b7169$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $286191e2308b7169$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            if (modifiers.includes("number")) return $286191e2308b7169$var$safeParseNumber(event.target.value);
            else if (modifiers.includes("boolean")) return $286191e2308b7169$var$safeParseBoolean(event.target.value);
            return modifiers.includes("trim") ? event.target.value.trim() : event.target.value;
        }
    });
}
function $286191e2308b7169$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $286191e2308b7169$var$isNumeric2(number) ? number : rawValue;
}
function $286191e2308b7169$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $286191e2308b7169$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $286191e2308b7169$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$286191e2308b7169$var$directive("cloak", (el)=>queueMicrotask(()=>$286191e2308b7169$var$mutateDom(()=>el.removeAttribute($286191e2308b7169$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$286191e2308b7169$var$addInitSelector(()=>`[${$286191e2308b7169$var$prefix("init")}]`);
$286191e2308b7169$var$directive("init", $286191e2308b7169$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$286191e2308b7169$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $286191e2308b7169$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$286191e2308b7169$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $286191e2308b7169$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $286191e2308b7169$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$286191e2308b7169$var$mapAttributes($286191e2308b7169$var$startingWith(":", $286191e2308b7169$var$into($286191e2308b7169$var$prefix("bind:"))));
var $286191e2308b7169$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $286191e2308b7169$var$injectBindingProviders(bindingProviders);
        let getBindings = $286191e2308b7169$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $286191e2308b7169$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $286191e2308b7169$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $286191e2308b7169$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $286191e2308b7169$var$mutateDom(()=>$286191e2308b7169$var$bind(el, value, result, modifiers));
        }));
};
$286191e2308b7169$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$286191e2308b7169$var$directive("bind", $286191e2308b7169$var$handler2);
function $286191e2308b7169$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$286191e2308b7169$var$addRootSelector(()=>`[${$286191e2308b7169$var$prefix("data")}]`);
$286191e2308b7169$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($286191e2308b7169$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $286191e2308b7169$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $286191e2308b7169$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $286191e2308b7169$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $286191e2308b7169$var$injectMagics(data2, el);
    let reactiveData = $286191e2308b7169$var$reactive(data2);
    $286191e2308b7169$var$initInterceptors2(reactiveData);
    let undo = $286191e2308b7169$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $286191e2308b7169$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $286191e2308b7169$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$286191e2308b7169$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $286191e2308b7169$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$286191e2308b7169$var$isCloning) return false;
    if ($286191e2308b7169$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$286191e2308b7169$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $286191e2308b7169$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $286191e2308b7169$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $286191e2308b7169$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $286191e2308b7169$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$286191e2308b7169$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $286191e2308b7169$var$parseForExpression(expression);
    let evaluateItems = $286191e2308b7169$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $286191e2308b7169$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$286191e2308b7169$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $286191e2308b7169$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($286191e2308b7169$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $286191e2308b7169$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $286191e2308b7169$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($286191e2308b7169$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $286191e2308b7169$var$mutateDom(()=>{
                if (!elForSpot) $286191e2308b7169$var$warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $286191e2308b7169$var$reactive(scope2);
            $286191e2308b7169$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $286191e2308b7169$var$mutateDom(()=>{
                lastEl.after(clone2);
                $286191e2308b7169$var$initTree(clone2);
            });
            if (typeof key === "object") $286191e2308b7169$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $286191e2308b7169$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $286191e2308b7169$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $286191e2308b7169$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $286191e2308b7169$var$handler3() {}
$286191e2308b7169$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $286191e2308b7169$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$286191e2308b7169$var$directive("ref", $286191e2308b7169$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$286191e2308b7169$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $286191e2308b7169$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $286191e2308b7169$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $286191e2308b7169$var$addScopeToNode(clone2, {}, el);
        $286191e2308b7169$var$mutateDom(()=>{
            el.after(clone2);
            $286191e2308b7169$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $286191e2308b7169$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($286191e2308b7169$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$286191e2308b7169$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$286191e2308b7169$var$setIdRoot(el, name));
});
// packages/alpinejs/src/directives/x-on.js
$286191e2308b7169$var$mapAttributes($286191e2308b7169$var$startingWith("@", $286191e2308b7169$var$into($286191e2308b7169$var$prefix("on:"))));
$286191e2308b7169$var$directive("on", $286191e2308b7169$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $286191e2308b7169$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $286191e2308b7169$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$286191e2308b7169$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$286191e2308b7169$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$286191e2308b7169$var$warnMissingPluginDirective("Focus", "trap", "focus");
$286191e2308b7169$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $286191e2308b7169$var$warnMissingPluginDirective(name, directiveName, slug) {
    $286191e2308b7169$var$directive(directiveName, (el)=>$286191e2308b7169$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$286191e2308b7169$var$alpine_default.setEvaluator($286191e2308b7169$var$normalEvaluator);
$286191e2308b7169$var$alpine_default.setReactivityEngine({
    reactive: $286191e2308b7169$var$reactive2,
    effect: $286191e2308b7169$var$effect2,
    release: $286191e2308b7169$var$stop,
    raw: $286191e2308b7169$var$toRaw
});
var $286191e2308b7169$var$src_default = $286191e2308b7169$var$alpine_default;
// packages/alpinejs/builds/module.js
var $286191e2308b7169$export$2e2bcd8739ae039 = $286191e2308b7169$var$src_default;


// packages/collapse/src/index.js
function $4a29384d5dd8cefb$var$src_default(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $4a29384d5dd8cefb$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $4a29384d5dd8cefb$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (el.getBoundingClientRect().height == full) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $4a29384d5dd8cefb$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $4a29384d5dd8cefb$export$2e2bcd8739ae039 = $4a29384d5dd8cefb$var$src_default;


// function addToCart(artNo: string) {
//     // var basketProducts = JSON.parse(localStorage.getItem("basketProducts"));
//     // var basketBtn = document.getElementById("basket-product");
//     // var removeObject = false;
//     //  if(basketProducts == null) {
//     //     basketProducts = [];
//     // }
//     // else {
//     //     for(var i = 0; i < basketProducts.length; i++){
//     //         if(basketProducts[i].artNo == artNo){
//     //             basketProducts.splice(i, 1);
//     //             removeObject = true;
//     //             basketBtn.classList.remove("inBasket");
//     //         }
//     //     }
//     // }
//     // var product = {        
//     //     "artNo": artNo,        
//     // };
//     // if(removeObject == false){
//     //     basketProducts.push(product);
//     //     basketBtn.classList.add("inBasket");
//     // }
//     // localStorage.setItem("basketProducts", JSON.stringify(basketProducts));
//     console.log(artNo);
// }


// Initialise alpine
(0, $286191e2308b7169$export$2e2bcd8739ae039).plugin((0, $4a29384d5dd8cefb$export$2e2bcd8739ae039));
(0, $286191e2308b7169$export$2e2bcd8739ae039).start();
document.addEventListener("DOMContentLoaded", ()=>{
    var cartItems = JSON.parse(localStorage.getItem("cartProducts"));
    var totalProducts = document.getElementById("total-products");
    if (cartItems != null && cartItems.length > 0) {
        totalProducts.style.display = "flex";
        totalProducts.innerText = cartItems.length;
    } else totalProducts.style.display = "none";
    if (document.querySelector(".splide") != undefined) {
        var splide = new (0, $6f5202a002b4b4fe$export$24494c7438c070bf)(".splide", {
            type: "loop",
            perPage: 4,
            focus: 0,
            omitEnd: true,
            gap: 30,
            mediaQuery: "min",
            breakpoints: {
                200: {
                    perPage: 1
                },
                640: {
                    perPage: 2
                },
                900: {
                    perPage: 3
                },
                1440: {
                    destroy: true
                }
            }
        });
        splide.mount();
    }
// if(document.getElementById('empty-localstorage')){
//     localStorage.clear();
// }
});

})();
//# sourceMappingURL=main.js.map
